import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as Sortable from 'sortablejs';
const SortableInstance = (Sortable as any).default || Sortable;
import Cropper from 'cropperjs';
import lottie from 'lottie-web';
import Values from 'values.js';
import Swiper from "swiper";
import { Location } from '@angular/common';

import {
  A11y,                // Accessibility support
  Autoplay,            // Autoplay functionality
  Controller,          // Control multiple Swipers
  EffectCards,         // 3D card-like effect
  EffectCoverflow,     // Coverflow 3D effect
  EffectCreative,      // Creative custom effects
  EffectCube,          // Cube 3D effect
  EffectFade,          // Fade effect
  EffectFlip,          // Flip 3D effect
  FreeMode,            // Free scrolling mode
  Grid,                // Grid layout
  HashNavigation,      // Hash URL navigation
  History,             // History navigation (URL-based)
  Keyboard,            // Keyboard control
  Manipulation,        // DOM manipulation (add/remove slides dynamically)
  Mousewheel,          // Mousewheel scrolling
  Navigation,          // Previous/Next buttons
  Pagination,          // Pagination (bullets, fractions, progress bars)
  Parallax,            // Parallax scrolling
  Scrollbar,           // Scrollbar for Swiper
  Thumbs,              // Thumbnail navigation
  Virtual,             // Virtual slides (lazy rendering)
  Zoom,                // Zoom functionality
} from 'swiper/modules';

import * as SwiperModules from 'swiper/modules';
import { combineLatest, map, Observable, Subject, Subscription } from 'rxjs';
import { SharedService } from 'src/app/services/shared.service';
import { HTTPService } from 'src/app/services/http.service';
import { SeoService } from 'src/app/seo.service';
import { environment } from 'src/environments/environment';
import { Constants } from 'src/app/common/Constants';
import { ConstantMessages } from 'src/app/common/ConstantMessages';
import * as signalR from '@microsoft/signalr';
import { MessageService } from 'src/app/common/message.service';
import { TitleCasePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from '../Login/Login.component';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationBoxComponent } from 'src/app/shared/components/confirmation-box/confirmation-box.component';
import { HowItWorksComponent } from 'src/app/shared/components/howitworks/howitworks.component';
import { FooterService } from 'src/app/footer.service';
import * as _ from 'lodash';
Swiper.use([A11y,                // Accessibility support
  Autoplay,            // Autoplay functionality
  Controller,          // Control multiple Swipers
  EffectCards,         // 3D card-like effect
  EffectCoverflow,     // Coverflow 3D effect
  EffectCreative,      // Creative custom effects
  EffectCube,          // Cube 3D effect
  EffectFade,          // Fade effect
  EffectFlip,          // Flip 3D effect
  FreeMode,            // Free scrolling mode
  Grid,                // Grid layout
  HashNavigation,      // Hash URL navigation
  History,             // History navigation (URL-based)
  Keyboard,            // Keyboard control
  Manipulation,        // DOM manipulation (add/remove slides dynamically)
  Mousewheel,          // Mousewheel scrolling
  Navigation,          // Previous/Next buttons
  Pagination,          // Pagination (bullets, fractions, progress bars)
  Parallax,            // Parallax scrolling
  Scrollbar,           // Scrollbar for Swiper
  Thumbs,              // Thumbnail navigation
  Virtual,             // Virtual slides (lazy rendering)
  Zoom,                // Zoom functionality
]);


@Component({
  selector: 'app-video-editor',
  templateUrl: './video-editor.component.html',
  styleUrls: ['./video-editor.component.scss'],
  providers: [HTTPService, MessageService, TitleCasePipe],
})
export class VideoEditorComponent implements OnInit {
  app: any;
  analytics: any;
  @ViewChild('swiperRef', { static: false }) swiperRef!: ElementRef;
  swiper!: Swiper;
  // DOM Elements
  @ViewChild('centralGuidedLine') centralGuidedLine!: ElementRef;
  @ViewChild('defaultTextPropertiesContainer') defaultTextPropertiesContainer!: ElementRef;
  @ViewChild('verticalContainer') verticalContainer!: ElementRef;
  @ViewChild('workspaceContainer') workspaceContainer!: ElementRef;
  @ViewChild('rearrangeClipsContainer') rearrangeClipsContainer!: ElementRef;
  @ViewChild('addClipsContainer') addClipsContainer!: ElementRef;
  @ViewChild('moreEditContainer') moreEditContainer!: ElementRef;
  @ViewChild('textEditContainer') textEditContainer!: ElementRef;
  @ViewChild('addEleContainer') addEleContainer!: ElementRef;
  @ViewChild('mobileAddEleContainer') mobileAddEleContainer!: ElementRef;
  @ViewChild('fontSizeDropdown') fontSizeDropdown!: ElementRef;
  @ViewChild('fontFamilyDropdown') fontFamilyDropdown!: ElementRef;
  @ViewChild('fontWeightDropdown') fontWeightDropdown!: ElementRef;
  @ViewChild('fontColorDropdown') fontColorDropdown!: ElementRef;
  @ViewChild('textAlignDropdown') textAlignDropdown!: ElementRef;
  @ViewChild('textLineHeightDropdown') textLineHeightDropdown!: ElementRef;

  // Mobile properties
  @ViewChild('mobileFontFamily') mobileFontFamily!: ElementRef;
  @ViewChild('mobileFontWeight') mobileFontWeight!: ElementRef;
  @ViewChild('mobileFontColor') mobileFontColor!: ElementRef;

  // Additional containers and inputs
  @ViewChild('imageOptionContainer') imageOptionContainer!: ElementRef;
  @ViewChild('imageInput') imageInput!: ElementRef;
  @ViewChild('editImageDisplayContainer') editImageDisplayContainer!: ElementRef;
  @ViewChild('editImageContainer') editImageContainer!: ElementRef;
  @ViewChild('displayUploadedImage') displayUploadedImage!: ElementRef;
  @ViewChild('uploadedImageContainer') uploadedImageContainer!: ElementRef;
  @ViewChild('cropAndSave') cropAndSave!: ElementRef;
  @ViewChild('flipBtnX') flipBtnX!: ElementRef;
  @ViewChild('flipBtnY') flipBtnY!: ElementRef;

  @ViewChild('rotateBtnX') rotateBtnX!: ElementRef;
  @ViewChild('rotateBtnY') rotateBtnY!: ElementRef;
  @ViewChild('swiperHorizontal') swiperHorizontal!: ElementRef;
  @ViewChild('videoTitle', { static: true }) videoTitle!: ElementRef;
  @ViewChild('caricatureModal', { static: true }) caricatureModal!: ElementRef;
  @ViewChild('musicCropModal', { static: true }) musicCropModal!: ElementRef;
  @ViewChild('canvas', { static: true }) canvas!: HTMLCanvasElement;

  subscription = new Subscription();
  // Button collections for rotations and flips
  TemplateAudio = [];
  audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
  audioBuffer: AudioBuffer | undefined;
  startTime: number = 0;
  endTime: number | undefined;
  canvasCtx!: CanvasRenderingContext2D | null;
  offscreenCanvas!: HTMLCanvasElement;
  offscreenCtx!: CanvasRenderingContext2D | null;
  startHandle!: HTMLElement;
  endHandle!: HTMLElement;
  playbackIndicator!: HTMLElement;
  croppedAudioSource!: AudioBufferSourceNode;
  playbackStartTime!: number;
  playbackRequest!: number;
  audioFile!: File;
  audioUrl!: string;
  selectedLanguage = 'english';
  public pTemplateId: any = '';
  public pUserVideoId: any = '';
  public marketingAgent: string;
  invitationType;
  videoOrCardTextCap = 'Video';
  videoOrCardTextSmall = 'video';
  public messageType: any;
  videoDesc = '';
  assetURL = environment.assetURL;
  TemplateMetaData: any = {};
  public constants: Constants;
  public constantMessages: ConstantMessages;
  public tempUserId = 0;
  public audioFilePath: string;
  public audioFileName: string;
  public uniqueTemplateId;
  connection: signalR.HubConnection;
  audioPath = '';
  previewStyle = '';
  public generatedVideoPath: string = '';
  public generatedDocumentPath: string = '';
  public isPayDisable: boolean = false;

  public isDraftSaved: boolean = false;
  public isInputChanged: boolean = false;
  public isSaveDisable: boolean = false;
  public videoPath: any = '';
  public documentPath: any = '';
  public progressPercentValue: any = 0;
  ProgressBarClass = 'c100 p0 green';
  ProgressTaskClass = 'mb-0 orange';
  ProgressBarPercentage = '0';
  Task1Width = 'width:0%';
  displayType: number = 1;
  public jobProgressData;
  public musicFileName;
  public initialVideoEditorState;
  // Image cropper
  cropper: any;
  cropperOptions: Cropper.Options<HTMLImageElement> = {
    aspectRatio: 1,
    viewMode: 1,
    dragMode: 'move',  // Use DragMode.Move instead of 'move'
    preview: '.preview',
    background: false,
  };
  fixedCroppedOptions: any;
  public isShowPreviewStatus: boolean = false;
  // Buttons
  // cropAndSave!: HTMLElement;
  // rotateBtn!: NodeListOf<HTMLElement>;
  // flipBtn!: NodeListOf<HTMLElement>;

  // Text properties
  currentSelectedText: any;

  // Initial coordinates
  startX = 0;
  startY = 0;

  // Element coordinates
  elementX = 0;
  elementY = 0;

  // Data variables
  defaultData: any;
  userData: any;
  defaultClipData: any;
  urlParameters: URLSearchParams;
  videoId: string | null;

  // Undo & Redo
  userActionHistory: any[] = [];
  currentHistoryPointer = -1;
  previousFontSizes: any = {};
  previousLineHeight: any = {};
  previousTextHTML: any = {};
  previousPosition: { [key: string]: { x: number; y: number } } = {};
  previousColor: any = {};
  previousWidth: any = {};
  previousLeft: any = {};
  centerGuidedLine;

  totalClipDuration: number = 0;
  @ViewChild('audioEle') audioEle!: ElementRef<HTMLAudioElement>;
  horizontalSwiper: any;
  verticalSwiper: any;
  // Font weight mapping
  fontWeightMap: { [key: string]: [string | number, string | number] } = {
    'normal': [400, 'normal'],
    'italic': [400, 'italic'],
    'Regular': [400, 'normal'],
    'Italic': [400, 'italic'],
    'Bold': [700, 'normal'],
    'Black': [900, 'normal'],
    'BoldItalic': [700, 'italic'],
    'BlackItalic': [900, 'italic'],
    'MediumBoldItalic': [500, 'italic'],
    'MediumBold': [500, 'normal'],
    'Light': [300, 'normal'],
    'LightItalic': [300, 'Italic'],
    'Thin': [100, 'normal'],
    'ThinItalic': [300, 'Italic']
  };

  fontData: any;

  // Image handling
  imageInputType = '';
  fixedImageEle: any;
  projectId: string;
  userId!: string;
  b2b: any;



  windowWidth = window.innerWidth;
  currentOpenedModal: any = '';
  previousSelectedTitleEle: any = ''
  userDetails: any = {};
  showFooter: boolean = false;
  isVisibleHeader: boolean = false;
  public globalWidth = 1080;
  public globalHeight = 1920;
  constructor(private route: ActivatedRoute, private renderer: Renderer2, private footerService: FooterService,
    private cdr: ChangeDetectorRef, private _router: Router,
    private _route: ActivatedRoute,
    public sharedService: SharedService, private _httpService: HTTPService,
    private seoService: SeoService,
    private messageService: MessageService,
    private ngbModel: NgbModal,
    public toastr: ToastrService,
    private modalService: NgbModal,
    private location: Location
  ) {

    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    if (this.userDetails != null && this.userDetails != undefined)
      this.tempUserId = this.userDetails.UserId;
    this.constants = new Constants();
    this.constantMessages = new ConstantMessages();
    this.messageType = this.constants.messageType;
    this.urlParameters = new URLSearchParams(window.location.search);
    this.videoId = this.urlParameters.get('videoID');
    this.subscription = this.footerService.showFooter$.subscribe((show) => {
      this.showFooter = show;
    });
    // if (this.videoId) {
    //   this.projectId = Math.random().toString(36).slice(5) + Math.random().toString(36).slice(5);
    // } else {
    //   this.projectId = this.urlParameters.get('orderID')!.split('_')[1];
    // }
  }

  ngOnInit() {
    this.footerService.setVisibility(false);
    this.renderer.addClass(document.body, 'video-editor-page');
    this.footerService.toggleWhatsappVisibility(false);
  }
  ngOnDestroy() {
    this.footerService.setVisibility(true);
    this.renderer.removeClass(document.body, 'video-editor-page');
    this.footerService.toggleWhatsappVisibility(true);
  }
  ngAfterViewInit() {
    this.subscription.add(
      combineLatest([this._route.params, this._route.queryParams])
        .pipe(map((results) => ({ params: results[0], query: results[1] })))
        .subscribe((results) => {
          const queryData = this.sharedService.decryptAndParseQueryString(
            results.params.data
          );
          if (queryData != undefined) {
            this.pTemplateId = queryData.templateId;
            this.pUserVideoId = queryData.userVideoId;
            this.marketingAgent = queryData.marketingAgent;
            this.invitationType = queryData.invitationType;
            if (this.invitationType == 2) {
              this.videoOrCardTextCap = 'Card';
              this.videoOrCardTextSmall = 'card';
            } else {
              this.invitationType = 1;
            }
          }
          this.videoDesc = results.params.videoDesc;
          this.sharedService.isShowLoader.next(true);
          // this.isSlideStepsLoading = true;
          if (!isNaN(this.pTemplateId) && this.pTemplateId > 0) {
            this.GetTemplateDataList();
          } else {
            this.GetUserVideoDataList();
          }
        })
    );
  }
  @HostListener('window:beforeunload')
  hasUnsavedData(): Observable<boolean> | boolean {
    let result = this.isInputChanged || this.isShowPreviewStatus;
    return result;
  }
  beforeUnloadHandler(event: any) {
    if (this.isInputChanged || this.isShowPreviewStatus) {
      return this.HandleEventDuringVideoGeneration(event);
    }
  }
  private HandleEventDuringVideoGeneration(event: any) {
    const subject = new Subject<boolean>();

    const modelRef = this.modalService.open(ConfirmationBoxComponent);
    modelRef.componentInstance.title = 'Plese confirm';
    modelRef.componentInstance.message =
      'WARNING: Video generation is in progress. Click “Okay” to save changes continue video creation OR click “Cancel Video Generation” to stop video creation and lose all changes.';
    modelRef.componentInstance.okButtonText = 'Cancel';
    modelRef.componentInstance.cancelButtonText = 'Okay';
    modelRef.componentInstance.subject = subject;
    modelRef.result.then((data: any) => {
      subject.complete();
    });
    event.preventDefault();
    return subject.asObservable();
  }

  private InitialiseVideoEditor() {
    this.initSwipers();
    this.initializeData();
    this.InitializeSortable();
    this.handleKeyPress();
    // this.canvasCtx = this.canvas.getContext('2d');
    // this.offscreenCanvas = document.createElement('canvas');
    // this.offscreenCtx = this.offscreenCanvas.getContext('2d');
    // this.startHandle = document.getElementById('startHandle');
    // this.endHandle = document.getElementById('endHandle');
    // this.playbackIndicator = document.getElementById('playbackIndicator');
    this.setupMusicCropper();
    this.imageInput.nativeElement.oninput = () => {
      const files = this.imageInput.nativeElement.files;
      if (files.length === 0) return;

      this.editImageContainer.nativeElement.style.display = 'flex';
      const file = files[0];
      const url = window.URL.createObjectURL(file);
      const userImg = document.createElement('img');
      userImg.src = url;

      this.editImageDisplayContainer.nativeElement.innerHTML = '';
      this.editImageDisplayContainer.nativeElement.appendChild(userImg);

      if (this.imageInputType === 'fixedImage') {
        this.cropper = new Cropper(userImg, this.fixedCroppedOptions);
      } else {
        this.cropper = new Cropper(userImg, this.cropperOptions);
      }

      this.rotateBtnX.nativeElement.onclick = () => this.cropper.rotate(-45);
      this.rotateBtnY.nativeElement.onclick = () => this.cropper.rotate(45);

      let [flipX, flipY] = [-1, -1];

      this.flipBtnX.nativeElement.onclick = () => {
        this.cropper.scale(flipX, 1);
        flipX = -flipX;
      };

      this.flipBtnY.nativeElement.onclick = () => {
        this.cropper.scale(1, flipY);
        flipY = -flipY;
      };

    };
  }

  public GetTemplateDataList() {
    this.subscription.add(
      this._httpService
        .ajaxPost('Personalize/GetTemplateData', {
          pTemplateId: this.pTemplateId,
        })
        .subscribe(
          (data) => {
            this.ProcessGetTemplate(data);
          },
          (error: any) => {
            this.sharedService.isShowLoader.next(false);
          }
        )
    );
  }
  public GetUserVideoDataList() {
    this.subscription.add(
      this._httpService
        .ajaxPost('Personalize/GetUserVideoDataList', {
          pUserVideoId: this.pUserVideoId,
        })
        .subscribe(
          (data) => {
            try {
              if (
                data['Message'].MessageTypeValue == this.messageType.Success
              ) {
                if (data.TemplateData.VideoStatus == 3) {
                  this.redirectToDownloadVideo();
                }
                this.sharedService.isPageDataLoaded = true;
                // this.isPersonalizeDataLoaded = true;
                var templateDataList = data['TemplateData'];
                this.seoService.generateTags({
                  title: `Personalise ${templateDataList.VideoName} | video invitation | Online Video Invitation Maker | Create Online Video Invitations - Wedding, Engagement, Birthday, Anniversary & more. - 247Invites.com`,
                  description: `Personalise ${templateDataList.VideoName} |  video invitation | Create Customized Video Invitations Online for Wedding, Engagement, Birthday, Reception, Anniversary, House warming, Naamkaran, Cradle, Baptism, Christening, Half Sari, Valentines Day, Christmas, Diwali, New Year, etc. Download and share using WhatsApp, Facebook, and more.`,
                  image: `${this.assetURL}/${templateDataList.ThumbnailImage}`,
                });
                if (this.userDetails != null)
                  this.TemplateMetaData.UserId = this.userDetails.UserId;
                this.TemplateMetaData.VideoEditorState = templateDataList.VideoEditorState;
                this.TemplateMetaData.UserVideoId =
                  templateDataList.UserVideoId;
                this.TemplateMetaData.TemplateId = templateDataList.TemplateId;
                this.TemplateMetaData.TemplateName =
                  templateDataList.TemplateName;
                this.TemplateMetaData.AudioPath = templateDataList.VideoEditorState.Music.Link;
                this.musicFileName = templateDataList.VideoEditorState.Music.Name;
                this.previewStyle = templateDataList.PreviewStyle;
                if (
                  (templateDataList.VideoPath != '') &&
                  templateDataList.IsUseS3Bucket == false
                ) {
                  this.generatedVideoPath =
                    this._httpService.baseURL + templateDataList.VideoPath;
                  this.generatedDocumentPath =
                    this._httpService.baseURL + templateDataList.DocumentPath;
                  this.isPayDisable = false;
                } else if (
                  templateDataList.VideoPath != '' &&
                  templateDataList.IsUseS3Bucket
                ) {
                  this.generatedVideoPath = templateDataList.VideoPath;
                  this.generatedDocumentPath = templateDataList.DocumentPath;
                  this.isPayDisable = false;
                } else this.isPayDisable = true;
                this.uniqueTemplateId = templateDataList.UniqueTemplateId;
                this.connectSignalR();
                this.hubConnectionOn();
                // this.HandleTemplateAudio(templateDataList);
                // this.TemplateMetaData.TemplateAudio = this.TemplateAudio;
                // let selectedAudio = this.TemplateMetaData.TemplateAudio.filter(
                //   (x) => x.AudioPath == this.TemplateMetaData.AudioPath
                // )[0];
                // if (selectedAudio == undefined || selectedAudio.length == 0) {
                //   this.HandleSingleTemplateAudio(
                //     this.TemplateMetaData.AudioPath
                //   );
                //   this.TemplateMetaData.TemplateAudio = this.TemplateAudio;
                //   // this.changeAudio(this.TemplateMetaData.AudioPath);
                // } else {
                //   // this.changeAudio(selectedAudio.AudioPath);
                // }
                this.InitialiseVideoEditor();

                // this.isSlideStepsLoading = false;
                // if (
                //   this.TemplateAudio.filter(
                //     (x) =>
                //       x.AudioPath == templateDataList.AudioPath && x.IsCustom
                //   ).length > 0
                // ) {
                //   this.IsDefaultAudio = false;
                //   this.uploadMusicText = 'Audio Uploaded!!';
                // }
              } else {
                this.messageService.showMessage(
                  data['Message'].Text,
                  data['Message'].MessageTypeValue
                );
              }
              this.sharedService.isShowLoader.next(false);
            } catch (error) {
              this.sharedService.isShowLoader.next(false);
            }
          },
          (error: any) => {
            if (error.status == 401) {
              localStorage.removeItem('userDetails');
              const modelRef = this.ngbModel.open(LoginComponent, {
                size: 'lg',
                windowClass: 'login-dialog',
              });
              modelRef.result.then((data) => {
                let userDetails = JSON.parse(
                  localStorage.getItem('userDetails')
                );
                if (userDetails != null && userDetails != '')
                  window.location.reload();
                else this._router.navigate(['homepage']);
              });
            }
            this.sharedService.isShowLoader.next(false);
          }
        )
    );
  }
  private redirectToDownloadVideo() {
    let encryptedqueryparams: { userVideoId: any };
    encryptedqueryparams = {
      userVideoId: this.pUserVideoId,
    };
    this._router.navigate([
      `/user/downloadvideo/${this.videoDesc}/${this.sharedService.encryptData(
        JSON.stringify(encryptedqueryparams)
      )}`,
    ]);
  }
  private HandleSingleTemplateAudio(audioPath: string) {
    var templateAudioObj = {
      AudioPath: '',
      AudioTitle: '',
      TemplateId: 0,
      AudioCoverPath: '',
      TemplateAudioId: 0,
      IsDefault: false,
      IsCustom: false,
    };
    templateAudioObj.AudioCoverPath = '';
    templateAudioObj.AudioTitle = this.replaceBetween(
      audioPath.replace(/^.*[\\\/]/, '_').replace(/\s/g, '_'),
      audioPath.lastIndexOf('_'),
      audioPath.lastIndexOf('.'),
      ''
    );
    templateAudioObj.AudioPath = audioPath;
    templateAudioObj.TemplateAudioId = -1;
    templateAudioObj.IsDefault = false;
    templateAudioObj.IsCustom = true;
    this.TemplateAudio.push(templateAudioObj);
  }
  private ProcessGetTemplate(data: any) {
    if (data['Message'].MessageTypeValue == this.messageType.Success) {
      this.sharedService.isPageDataLoaded = true;
      var templateDataList = data['TemplateData'];
      this.displayType = templateDataList.DisplayType;
      this.seoService.generateTags({
        title: `Personalise ${templateDataList.VideoName} | video invitation | Online Video Invitation Maker | Create Online Video Invitations - Wedding, Engagement, Birthday, Anniversary & more. - 247Invites.com`,
        description: `Personalise ${templateDataList.VideoName} video invitation | Create Customized Video Invitations Online for Wedding, Engagement, Birthday, Reception, Anniversary, House warming, Naamkaran, Cradle, Baptism, Christening, Half Sari, Valentines Day, Christmas, Diwali, New Year, etc. Download and share using WhatsApp, Facebook, and more.`,
        image: `${this.assetURL}/${templateDataList.ThumbnailImage}`,
        slug: this._router.url,
      });
      if (this.userDetails != null)
        this.TemplateMetaData.UserId = this.userDetails.UserId;
      this.TemplateMetaData.UserVideoId = templateDataList.UserVideoId;
      this.TemplateMetaData.TemplateId = templateDataList.TemplateId;
      this.TemplateMetaData.TemplateName = templateDataList.TemplateName;
      this.TemplateMetaData.VideoDuration = templateDataList.VideoDuration;
      this.TemplateMetaData.AudioPath = templateDataList.AudioPath;
      this.TemplateMetaData.VideoEditorState = templateDataList.VideoEditorState;
      this.musicFileName = this.TemplateMetaData.VideoEditorState.Music.Name;
      this.audioFilePath =
        this._httpService.baseURLWithOutSlace +
        (templateDataList.AudioPath.indexOf('.') == 0
          ? templateDataList.AudioPath.substring(1)
          : templateDataList.AudioPath);
      this.audioFileName = this.audioFilePath
        .replace(/^.*[\\\/]/, '_')
        .replace(/\s/g, '_');
      this.audioFileName = this.replaceBetween(
        this.audioFileName,
        this.audioFileName.lastIndexOf('_'),
        this.audioFileName.lastIndexOf('.'),
        ''
      );
      this.uniqueTemplateId = templateDataList.UniqueTemplateId;
      this.connectSignalR();
      this.hubConnectionOn();
      this.TemplateMetaData.AudioPath = this.TemplateMetaData.VideoEditorState.Music.Link;
      //this.HandleTemplateAudio(templateDataList);
      // this.TemplateMetaData.TemplateAudio = this.TemplateAudio;
      // let selectedAudio = this.TemplateMetaData.TemplateAudio.filter(
      //   (x) => x.IsDefault == true
      // )[0];
      // this.audioPath = selectedAudio.AudioPath;
      this.InitialiseVideoEditor();
      // this.changeAudio(selectedAudio.AudioPath);
      // this.isSlideStepsLoading = false;
      this.isPayDisable = true;
    } else {
      this.messageService.showMessage(
        data['Message'].Text,
        data['Message'].MessageTypeValue
      );
      // this.isSlideStepsLoading = false;
    }
    this.sharedService.isShowLoader.next(false);
  }
  private HandleTemplateAudio(templateDataList: any) {
    templateDataList.TemplateAudio.forEach((element) => {
      var templateAudioObj = {
        AudioPath: '',
        AudioTitle: '',
        TemplateId: 0,
        AudioCoverPath: '',
        TemplateAudioId: 0,
        IsDefault: false,
        IsCustom: false,
      };
      templateAudioObj.AudioCoverPath = element.AudioCoverPath;
      templateAudioObj.AudioTitle = element.AudioTitle;
      templateAudioObj.TemplateId = element.TemplateId;
      templateAudioObj.AudioPath = element.AudioPath;
      templateAudioObj.TemplateAudioId = element.TemplateAudioId;
      templateAudioObj.IsDefault = element.IsDefault;
      this.TemplateAudio.push(templateAudioObj);
    });
  }
  public connectSignalR = () => {
    console.log('connect');
    this.connection = new signalR.HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Information)
      .withUrl(`${this._httpService.baseURL}jobprogress`)
      .build();
    this.connection.serverTimeoutInMilliseconds = 1000 * 60 * 1000;
    this.connection
      .start()
      .then(() => { })
      .catch(function (err) {
        return console.error(err.toString());
      });
  };
  public invokeHubConnection = () => {
    let uniqueTemplateId = this.uniqueTemplateId;
    if (uniqueTemplateId != null) {
      if (this.connection.state == signalR.HubConnectionState.Disconnected) {
        this.connection.start().then(() => {
          this.connection
            .invoke('AssociateJob', `${uniqueTemplateId}`)
            .catch(function (e) { })
            .finally(() => {
              this.processVideoGeneration();
            });
        });
      } else {
        this.connection
          .invoke('AssociateJob', `${uniqueTemplateId}`)
          .catch(function (e) { })
          .finally(() => {
            this.processVideoGeneration();
          });
      }
    } else {
      this.connection.invoke('AssociateJob', 'UnKnown');
    }
  };
  public hubConnectionOn = () => {
    this.connection.on('progress', (data) => {
      let responsedata = JSON.parse(data);
      if (responsedata != undefined) {
        this.jobProgressData = responsedata;
        this.Task1Width = 'width:100%';
        this.ProgressBarPercentage = responsedata.TaskCompletePercentage;
        this.ProgressBarClass = `c100 p${responsedata.TaskCompletePercentage} green`;
        this.Task1Width = 'width:100%';
        if (parseInt(this.ProgressBarPercentage) > 0) {
          this.ProgressTaskClass = 'green mb-0';
        }
      }
    });
  };
  processVideoGeneration() {
    this.TemplateMetaData.VideoStatus = this.constants.videoStatus.Previewed;
    this.TemplateMetaData.UniqueTemplateId = this.uniqueTemplateId;
    this.isShowPreviewStatus = true;

    this.isSaveDisable = true;
    this.subscription.add(
      this._httpService
        .ajaxPost('Personalize/UpdateTemplate', {
          TemplateMetaData: this.TemplateMetaData,
        })
        .subscribe(
          (data) => {
            if (
              data['Message'] != undefined &&
              data['Message'].Text.toLowerCase() == 'stop process'
            )
              return;
            try {
              if (
                data['Message'].MessageTypeValue == this.messageType.Success
              ) {
                this.initialVideoEditorState = { ...this.TemplateMetaData.VideoEditorState };

                if (data['IsUseS3Bucket']) {
                  this.videoPath = data['VideoPath'];
                  this.documentPath = data['DocumentPath'];
                } else {
                  this.videoPath =
                    this._httpService.baseURL + data['VideoPath'];
                  this.documentPath =
                    this._httpService.baseURL + data['DocumentPath'];
                }
                if (data['VideoPath'] != '' || data['DocumentPath'] != '') {
                  this.generatedVideoPath = this.videoPath;
                  this.generatedDocumentPath = this.documentPath;
                  this.isPayDisable = false;
                } else this.isPayDisable = true;
                this.isShowPreviewStatus = false;
                this.ProgressBarPercentage = '0';
                this.ProgressBarClass = `c100 p${0} green`;
                this.openHowItWorksDialog(this.videoPath, this.documentPath);
              } else {
                this.isPayDisable = true;
                this.isShowPreviewStatus = false;
                // this.messageService.showMessage(data["Message"].Text, data["Message"].MessageTypeValue);
                if (
                  data['Message'] != undefined &&
                  data['Message'].MessageTypeValue ==
                  this.messageType.RequestExist
                ) {
                  const modelRef = this.modalService.open(
                    ConfirmationBoxComponent
                  );
                  modelRef.componentInstance.title =
                    'Video already in generation';
                  modelRef.componentInstance.message = `You are already generating another video. Please note that only one video can be generated per user at a time. Kindly proceed with this request once you have completed the preview of the previous one.`;
                  modelRef.componentInstance.okButtonText = 'Okay';
                  modelRef.componentInstance.cancelButtonText = 'Cancel';
                } else {
                  this.videoGenerationError();
                }
              }
              this.isSaveDisable = false;
            } catch (error) {
              this.isPayDisable = true;
              this.isSaveDisable = false;
              console.error(error);
              this.isShowPreviewStatus = false;
            }
          },
          (error: any) => {
            this.isShowPreviewStatus = false;
            this.isSaveDisable = false;
          }
        )
    );
  }

  openHowItWorksDialog(path: string, documentPath: string): void {
    let dialogRef = this.modalService.open(HowItWorksComponent, {
      size: 'lg',
      windowClass: 'preview-video-dialog',
    });
    dialogRef.componentInstance.userVideoId = this.pUserVideoId;
    dialogRef.componentInstance.videoPath = path;
    dialogRef.componentInstance.documentPath = documentPath;
    dialogRef.componentInstance.UserId = this.userDetails.UserId;
    dialogRef.componentInstance.displayType = this.displayType;
    dialogRef.componentInstance.previewStyle = this.previewStyle;
    dialogRef.componentInstance.invitationType = this.invitationType;

    dialogRef.result.then((data) => {
      if (data) {
        this.sharedService.isShowLoader.next(true);
        this.subscription.add(
          this._httpService
            .ajaxPost(
              `Personalize/CheckVideoStatus/${this.pUserVideoId}/${this.invitationType}`,
              null
            )
            .subscribe(
              (data: any) => {
                if (data) {
                  this.ProcessPayAndDownload();
                } else {
                  this.sharedService.isShowLoader.next(false);
                  this.SaveTemplateData(true);
                }
              },
              () => {
                this.sharedService.isShowLoader.next(false);
                this.SaveTemplateData(true);
              }
            )
        );
      }
    });
  }
  payAndDownload() {
    this.sharedService.isShowLoader.next(true);
    if (this.isShowPreviewStatus) {
      return;
    }
    this.subscription.add(
      this._httpService
        .ajaxPost(
          `Personalize/CheckVideoStatus/${this.pUserVideoId}/${this.invitationType}`,
          null
        )
        .subscribe(
          (data: any) => {
            if (data) {
              this.ProcessPayAndDownload();
            } else {
              this.sharedService.isShowLoader.next(false);
              this.GenerateVideo(1);
            }
          },
          () => {
            this.sharedService.isShowLoader.next(false);
            this.videoGenerationError();
          }
        )
    );
  }
  private ProcessPayAndDownload() {
    if (
      this.generatedVideoPath.length !== 0 ||
      this.generatedDocumentPath.length !== 0
    ) {
      let encryptedqueryparams: { userVideoId: any };
      encryptedqueryparams = {
        userVideoId: this.pUserVideoId,
      };
      this.sharedService.isShowLoader.next(true);
      let objLog = Object.assign({});
      objLog.UserId = this.userDetails.UserId;
      objLog.MethodName = 'Pay & Downlaod';
      objLog.IsSuccess = true;
      objLog.Description = `User clicked download => ${this.generatedVideoPath}`;
      objLog.IPAddress = this.sharedService.ipAddress;
      this.subscription.add(
        this._httpService
          .ajaxPost('Personalize/AddLog', objLog)
          .subscribe((data) => {
            this.sharedService.isShowLoader.next(false);
            this._router.navigate([
              `/userpayment/${this.videoDesc}/${this.sharedService.encryptData(
                JSON.stringify(encryptedqueryparams)
              )}`,
            ]);
          })
      );
    } else {
      this.toastr.warning(
        'Please generate the preview video first and then you can proceed for payment.'
      );
      this.isPayDisable = true;
      setTimeout(() => {
        this.isPayDisable = false;
      }, 5000);
    }
  }
  videoGenerationError() {
    this.isInputChanged = true;
    const modelRef = this.modalService.open(ConfirmationBoxComponent);
    modelRef.componentInstance.title =
      'Unexpected Error While Generating a Video';
    modelRef.componentInstance.message = `We hit a bit of a unexpected error while making your video/card. 
    No worries, though! Your video details are saved in "My Videos" section and you can give it another try for video generation. <strong style='color:#ED256B'> If you run into any trouble again or have questions, just reach out to our friendly support executive on a website chat or on WhatsApp at +91 8669278777 </strong>. 
    We're always here to assist you and make things as smooth as possible for you.`;
    modelRef.componentInstance.okButtonText = 'Okay';
    modelRef.componentInstance.cancelButtonText = 'Cancel';
  }
  cropAndSaveAction() {
    {
      const croppedCanvas = this.cropper.getCroppedCanvas();
      const imageData = croppedCanvas.toDataURL('image/png').split(',');
      const mime = imageData[0].match(/:(.*?);/)![1];
      const bstr = atob(imageData[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      const imageBlob = new Blob([u8arr], { type: mime });
      const blobLink = window.URL.createObjectURL(imageBlob);
      const imageContainer = document.createElement('div');
      const image = document.createElement('img');
      image.src = blobLink;
      imageContainer.appendChild(image);
      this.uploadedImageContainer.nativeElement.appendChild(imageContainer);

      this.cropper.destroy();
      this.imageInput.nativeElement.value = '';
      this.editImageContainer.nativeElement.style.display = 'none';
      this.displayUploadedImage.nativeElement.style.display = 'flex';

      if (this.imageInputType === 'fixedImage' || this.imageInputType === 'caricature') {
        (this.fixedImageEle as HTMLImageElement).src = blobLink;
        this.imageInputType = '';
      } else {
        this.addImageInClip(blobLink);
        imageContainer.onclick = () => {
          this.addImageInClip(blobLink);
        };
      }
    };
  }

  initSwipers() {
    this.verticalSwiper = new Swiper(".vertical-clips-container", {
      direction: "vertical",
      spaceBetween: "5%",
      slidesPerView: "auto",
      freeMode: true,
      passiveListeners: true,
      resizeObserver: true,
      updateOnWindowResize: true,
      watchSlidesProgress: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      }
    });
    this.horizontalSwiper = new Swiper(".horizontal-clips-container", {
      slidesPerView: 1,
      observer: true,
      observeParents: true,
      parallax: true,
      navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      thumbs: {
        swiper: this.verticalSwiper,
      }
    });

    this.verticalSwiper.on('init', () => {
      setTimeout(() => {
        this.verticalSwiper.slides[0].classList.add("swiper-slide-active");
      }, 1000);
    });

    this.horizontalSwiper.on("slideChangeTransitionStart", () => {
      this.setDefaultTextProperties();
    });

    this.verticalSwiper.on("slideChangeTransitionStart", () => {
      this.horizontalSwiper.slideTo(this.horizontalSwiper.activeIndex);
    });
  }

  InitializeSortable() {
    let sortableDelayRPages = window.innerWidth < 700 ? 500 : 0;
    new SortableInstance(this.rearrangeClipsContainer.nativeElement, {
      ghostClass: 'ghost',
      animation: 400,
      easing: 'cubic-bezier(1, 0, 0, 1)',
      chosenClass: 'sortable-chosen',
      dragClass: 'sortable-drag',
      delay: sortableDelayRPages,
      handle: '.dragger'
    });
  }

  initializeData(): any {
    try {
      // Fetch user data and default data
      let videoId = 123;
      if (!videoId) {
        // this.userData = await this.dataService.fetchUserData().toPromise();
        // this.defaultData = await this.dataService.fetchDefaultData().toPromise();

        // if (this.userData['caricature']) {
        //   const groomImage = document.getElementById('groomImage') as HTMLImageElement;
        //   const brideImage = document.getElementById('brideImage') as HTMLImageElement;

        //   groomImage.src = this.userData['coupleImages']['groomImage'];
        //   brideImage.src = this.userData['coupleImages']['brideImage'];
        // }

        // const videoTitle = document.getElementById('video-title') as HTMLInputElement;
        // const customMusicName = document.getElementById('custom-music-name') as HTMLElement;

        // videoTitle.value = this.userData['title'];
        // customMusicName.innerText = this.userData['music']['name'];
        // this.audioEle.nativeElement.src = this.userData['music']['link'];
      } else {
        // this.defaultData = this.getVideoData()['result']['video'];
        // this.userData = this.defaultData['json'];
        // this.audioEle.nativeElement.src = 'https://invitoai.com/zcollection/samplemusic.mp3';
        this.defaultData = this.convertPascalToCamel(this.TemplateMetaData.VideoEditorState);
        this.initialVideoEditorState = { ...this.defaultData };
        this.globalHeight = this.defaultData?.height ?? 1920;
        this.globalWidth = this.defaultData?.width ?? 1080;
        this.userData = this.defaultData;
        this.audioEle.nativeElement.src = this.defaultData.music.link;
      }

      //this.changePriceAccordingToCurrency();
      this.startLoader();

      const userClipData = this.userData['clips'];
      this.defaultClipData = userClipData;

      for (let i = 0; i < userClipData.length; i++) {
        let scale;
        this.totalClipDuration += parseFloat(userClipData[i]['clipDuration']);
        scale = this.generateClipsContainer(this.verticalContainer.nativeElement, 'vertical', i, userClipData[i]);
        this.setImageAndText(document.getElementById(`vertical-clip-${i}`) as HTMLElement, scale, userClipData[i], 'vertical', i);

        scale = this.generateClipsContainer(this.workspaceContainer.nativeElement, 'horizontal', i, userClipData[i]);
        this.setImageAndText(document.getElementById(`horizontal-clip-${i}`) as HTMLElement, scale, userClipData[i], 'horizontal', i);
      }

      for (let i = 0; i < this.defaultClipData.length; i++) {
        let scale = this.generateRearrangeClipsContainer(this.addClipsContainer.nativeElement, 'add', i, this.defaultClipData[i]);
        this.setImageAndText(document.getElementById(`add-clip-${i}`) as HTMLElement, scale, this.defaultClipData[i], 'add', i);
      }

      this.addFontSize();
      this.addFontStyling();
      this.addColors();

      const textArea = document.getElementById('text-area-0') as HTMLElement;
      textArea.addEventListener('input', this.changeTextInWorkspace);

      const musicClipDuration = document.querySelector('.music-container .clip-duration') as HTMLElement;
      musicClipDuration.innerHTML = this.formatTime(this.totalClipDuration);
      this.getMusicTime();

      if (this.userData['fixedImages'].length === 0) {
        document.querySelectorAll('.fixed-image-title, .fixed-images-container').forEach((ele) => {
          (ele as HTMLElement).style.display = 'none';
        });
      } else {
        this.setFixedImages(this.userData['fixedImages']);
      }

      if (!this.userData['caricature']) {
        const coupleImages = document.querySelector('.couple-images') as HTMLElement;
        coupleImages.style.display = 'none';
      }

      setTimeout(() => {
        this.setDefaultTextProperties();

        const activeHorizontalClip = document.getElementById(`horizontal-clip-${this.horizontalSwiper.activeIndex}`) as HTMLElement;
        this.adjustCentralGuidedLine(activeHorizontalClip);

        const rearrangeContainer = document.querySelector('.rearrange-container') as HTMLElement;
        rearrangeContainer.style.display = 'none';
        rearrangeContainer.style.visibility = 'visible';

        this.stopLoader();
      }, 7000);
    } catch (error) {
      console.error('Error initializing data:', error);
    }
  }

  adjustCentralGuidedLine(activeHorizontalClip: HTMLElement): void {
    const centralLine = this.centralGuidedLine.nativeElement;

    this.renderer.setStyle(
      centralLine,
      'height',
      `${activeHorizontalClip.offsetHeight}px`
    );
    this.renderer.setStyle(
      centralLine,
      'top',
      `${activeHorizontalClip.offsetTop}px`
    );
    this.renderer.setStyle(
      centralLine,
      'left',
      `${activeHorizontalClip.parentElement.offsetWidth / 2}px`
    );
  }
  handleKeyPress() {
    this.renderer.listen('window', 'keydown', (e: KeyboardEvent) => {
      if ((e.key === 'Z' || e.key === 'z') && e.ctrlKey) {
        this.undo();
      } else if ((e.key === 'Y' || e.key === 'y') && e.ctrlKey) {
        this.redo();
      }
    });
  }

  // Change price according to currency
  changePriceAccordingToCurrency(): void {
    const currencyElement = document.querySelector('.choose-currency input:checked') as HTMLInputElement;
    let price, strikePrice, sign;

    // Access dataset['sign'] to avoid the error
    if (this.userData['type'] == 'draft' || window.location.href.includes('videoID')) {
      if (currencyElement.value.toLowerCase() === 'inr') {
        price = this.defaultData['price'];
        strikePrice = this.defaultData['price'] * 2 + 1;
        sign = currencyElement.dataset['sign']; // Access with ['sign']
        (document.querySelector('.create-video-btn .create-video p .gst-info') as HTMLElement).style.display = 'block';
      } else {
        price = Math.round(this.defaultData['price'] * 0.012 + 1);
        strikePrice = Math.round(this.defaultData['price'] * 0.012 + 1) * 2;
        sign = currencyElement.dataset['sign']; // Access with ['sign']
        (document.querySelector('.create-video-btn .create-video p .gst-info') as HTMLElement).style.display = 'none';
      }
    } else {
      if (currencyElement.value.toLowerCase() === 'inr') {
        price = 100;
        sign = currencyElement.dataset['sign']; // Access with ['sign']
        (document.querySelector('.create-video-btn .create-video p .gst-info') as HTMLElement).style.display = 'block';
      } else {
        price = Math.round(100 * 0.012 + 1);
        sign = currencyElement.dataset['sign']; // Access with ['sign']
        (document.querySelector('.create-video-btn .create-video p .gst-info') as HTMLElement).style.display = 'none';
      }
    }

    (document.querySelector('.create-video-btn .create-video p .price') as HTMLElement).innerHTML = `${sign} ${price}`;
    if (document.querySelector('.create-video-btn .create-video p .strike-price')) {
      (document.querySelector('.create-video-btn .create-video p .strike-price') as HTMLElement).innerHTML = `${sign} ${strikePrice || ''}`;
    }
    (document.querySelector('.draft-modal .price') as HTMLElement).innerHTML = `${sign} ${price}`;
    if (document.querySelector('.draft-modal .strike-price')) {
      (document.querySelector('.draft-modal .strike-price') as HTMLElement).innerHTML = `${sign} ${strikePrice || ''}`;
    }
  }

  // Generate clips container dynamically
  generateClipsContainer(parent: HTMLElement, clipDirection: string, i: number, data: any): any {
    let scale = 0;
    const swiperContainer = document.createElement('div');
    swiperContainer.classList.add('swiper-slide');
    const container = document.createElement('div');
    container.classList.add('clips-container');
    container.id = `${clipDirection}-clip-${i}`;
    container.setAttribute('data-name', data.name);
    container.setAttribute('data-src', data.image);
    container.setAttribute('data-bufferStart', data.bufferStart);
    container.setAttribute('data-bufferEnd', data.bufferEnd);
    container.setAttribute('data-clipDuration', data.clipDuration);

    if (clipDirection === 'vertical') {
      scale = parent.offsetWidth * 0.6 / this.globalWidth;
      container.style.width = `${parent.offsetWidth * 0.6}px`;
    } else {
      scale = parent.offsetHeight * 0.9 / this.globalHeight;
      container.style.height = `${parent.offsetHeight * 0.9}px`;
    }

    swiperContainer.appendChild(container);
    parent.appendChild(swiperContainer);
    return scale;
  }

  // Set image and text for each clip
  setImageAndText(container: HTMLElement, scale: number, clip: any, clipDirection: string, i: number): any {
    const image = document.createElement('img');
    image.src = clip.image;
    image.style.height = '100%';
    image.style.width = '100%';
    image.style.userSelect = 'none';
    image.style.pointerEvents = 'none';
    image.onload = () => {
      this.verticalSwiper.update();
      this.horizontalSwiper.update();
      container.appendChild(image);
      this.setText(container, scale, clip, clipDirection, i);
      if (clipDirection != 'add') this.setIcon(container, scale, clip, clipDirection, i)
    };
  }

  // Set text for each clip
  setText(
    parent: HTMLElement,
    scale: number,
    clip: any,
    clipDirection: string,
    clipIndex: number
  ): void {
    const allTexts = clip['text'];

    allTexts.forEach((textProperties: any, i: number) => {
      const textContainer = this.renderer.createElement('div');
      const text = this.renderer.createElement('p');
      this.renderer.setProperty(text, 'innerText', textProperties['text']);

      this.renderer.addClass(textContainer, 'clip-text');
      this.renderer.setAttribute(
        textContainer,
        'data-name',
        textProperties['name']
      );

      this.renderer.setAttribute(
        textContainer,
        'start-animation',
        textProperties['startAnimation'] || ''
      );

      this.renderer.setAttribute(
        textContainer,
        'id',
        `${clipDirection}clip-${clipIndex}-text-${i}`
      );
      this.renderer.addClass(text, 'text');

      const fontStyle = textProperties['fontStyle'];
      if (fontStyle === 'normal') {
        this.renderer.setAttribute(textContainer, 'font-style', 'Regular');
      } else if (fontStyle === 'italic') {
        this.renderer.setAttribute(textContainer, 'font-style', 'Italic');
      } else {
        this.renderer.setAttribute(textContainer, 'font-style', fontStyle);
      }

      this.renderer.setStyle(
        textContainer,
        'fontWeight',
        this.fontWeightMap[fontStyle][0]
      );
      this.renderer.setStyle(
        textContainer,
        'fontStyle',
        this.fontWeightMap[fontStyle][1]
      );

      this.renderer.setStyle(
        textContainer,
        'fontSize',
        textProperties['fontSize'] * scale + 'px'
      );

      this.renderer.setStyle(
        textContainer,
        'lineHeight',
        textProperties['lineHeight']
          ? parseFloat(textProperties['lineHeight'])
          : 1
      );

      this.renderer.setStyle(
        textContainer,
        'fontFamily',
        `'${textProperties['fontFamily']}'`
      );

      this.renderer.setStyle(
        textContainer,
        'textAlign',
        textProperties['textAlign']
      );

      this.renderer.setStyle(
        textContainer,
        'color',
        textProperties['color']
      );

      if (textProperties['duplicate']) {
        textContainer.dataset.duplicate = textProperties['duplicate'];
      }

      this.renderer.setStyle(textContainer, 'width', 'max-content');
      this.renderer.appendChild(textContainer, text);

      this.renderer.setStyle(
        textContainer,
        'top',
        textProperties['top'] * scale - 5 + 'px'
      );

      this.renderer.appendChild(parent, textContainer);

      setTimeout(() => {
        this.renderer.setStyle(
          textContainer,
          'left',
          textProperties['left'] * scale - textContainer.offsetWidth / 2 + 'px'

        );
      }, 400);

      if (clipDirection === 'horizontal') {
        this.addTextEventListeners(textContainer);
      }
    });
  }

  setIcon(parent: HTMLElement, scale: number, clip: any, clipDirection: string, clipIndex: number): any {
    if (!clip['userImage']) return;
    let allImages = clip['userImage'];

    for (const [i, imageProperties] of allImages.entries()) {
      const imageContainer = document.createElement('div');
      imageContainer.classList.add('clip-text', 'user-image');
      imageContainer.setAttribute('id', `${clipDirection}clip-${clipIndex}-image-${i}`);
      imageContainer.style.zIndex = '2';

      const image = document.createElement('img');
      image.src = imageProperties['url'];
      image.style.height = 'auto';
      image.style.width = `${imageProperties['width'] * scale}px`;

      image.onload = () => {
        imageContainer.style.top = `${(imageProperties['top'] * scale) - (imageContainer.offsetHeight / 2)}px`;
        imageContainer.style.left = `${(imageProperties['left'] * scale) - (imageContainer.offsetWidth / 2)}px`;
      };

      imageContainer.append(image);
      parent.append(imageContainer);

      if (clipDirection === 'horizontal') {
        this.addTextEventListeners(imageContainer);
        this.renderer.setStyle(this.displayUploadedImage.nativeElement, 'display', 'flex');
        if (this.uploadedImageContainer) {
          const saveImageContainer = document.createElement('div');
          const customImage = document.createElement('img');
          this.uploadedImageContainer.nativeElement.append(saveImageContainer);
          customImage.src = imageProperties['url'];

          saveImageContainer.onclick = () => {
            this.addImageInClip(imageProperties['url']);
          };
          saveImageContainer.append(customImage);
        }
      }
    }
  }

  setFixedImages(fixedImages: any[]): any {
    const fixedImagesContainer = document.querySelector('.fixed-images-container');
    if (fixedImagesContainer) {
      fixedImages.forEach((imageData) => {
        const container = document.createElement('div');
        container.classList.add('fixed-image');
        container.setAttribute('image-width', imageData['width']);
        container.setAttribute('image-height', imageData['height']);
        container.setAttribute('image-visibility', imageData['visible']);
        if (imageData['visible'] == false) {
          container.setAttribute('style', "display:none");
        }
        const img = document.createElement('img');
        img.src = imageData['link'];

        const actionBtnContainer = document.createElement('div');
        actionBtnContainer.classList.add('action-button');
        actionBtnContainer.onclick = () => {
          this.changeFixedImage(actionBtnContainer);
        };

        const icon = document.createElement('i');
        icon.classList.add('fa-solid', 'fa-arrow-up-from-bracket');

        const text = document.createElement('p');
        text.innerHTML = 'Change Image';
        actionBtnContainer.append(icon, text);
        container.append(img, actionBtnContainer);

        fixedImagesContainer.append(container);
      });
    }
  }

  addTextEventListeners(text: HTMLElement): any {
    text.addEventListener('click', (e) => {
      if (this.windowWidth < 576) {
        this.horizontalSwiper.disable();
        if (!text.classList.contains('user-image')) {
          const textPropertiesContainer = document.querySelector('.text-properties-container') as HTMLElement;
          const bottomPropertiesContainer = document.querySelector('.bottom-properties-container') as HTMLElement;
          const bottomProperties = document.querySelector('.bottom-properties-container .properties') as HTMLElement;

          if (textPropertiesContainer) {
            textPropertiesContainer.style.display = 'none';
          }

          if (bottomPropertiesContainer) {
            bottomPropertiesContainer.style.display = 'flex';
          }

          if (bottomProperties) {
            bottomProperties.style.display = 'flex';
          }
        }
      }

      e.stopPropagation();
      if (this.currentSelectedText && this.currentSelectedText !== text) {
        this.currentSelectedText.classList.remove('active');
        this.currentSelectedText.querySelector('.active-border').remove();
        this.currentSelectedText.querySelector('.active-option').remove();
        this.currentSelectedText.contentEditable = false;
      }

      if (this.currentSelectedText !== text || !this.currentSelectedText) {
        const activeBorderDiv = document.createElement('div');
        activeBorderDiv.classList.add('active-border');

        const options = document.createElement('div');
        options.classList.add('active-option');

        const selectOptions = document.createElement('div');
        selectOptions.classList.add('active-options');

        const deleteIcon = document.createElement('i');
        deleteIcon.classList.add('fa-solid', 'fa-trash', 'active-delete');
        deleteIcon.onclick = (e) => this.deleteText(e);

        const duplicateIcon = document.createElement('i');
        duplicateIcon.classList.add('fa-regular', 'fa-clone', 'active-duplicate');
        duplicateIcon.onclick = (e) => this.duplicateText(e);

        selectOptions.append(deleteIcon, duplicateIcon);

        const moveIcon = document.createElement('i');
        moveIcon.classList.add('fa-solid', 'fa-up-down-left-right', 'active-move');

        const resizeIcon = document.createElement('i');
        resizeIcon.classList.add('fa-solid', 'fa-arrows-up-down', 'active-resize');
        resizeIcon.onpointerdown = (e) => this.increaseSizeByDrag(e, resizeIcon, text.closest('.clips-container'));

        activeBorderDiv.append(selectOptions);
        options.append(moveIcon, selectOptions, resizeIcon);
        text.append(activeBorderDiv, options);
        text.classList.add('active');
      }

      this.currentSelectedText = text;
      this.currentSelectedText.addEventListener('pointerdown', this.pointerDown);
      this.currentSelectedText.parentElement.addEventListener('pointerdown', this.resetTextDecorationToDefault);
      this.currentSelectedText.parentElement.parentElement.addEventListener('pointerdown', this.resetTextDecorationToDefault);

      if (!text.classList.contains('user-image')) {
        this.currentSelectedText.addEventListener('dblclick', () => {
          this.currentSelectedText.querySelector('.text').contentEditable = true;
          this.currentSelectedText.querySelector('.text').oninput = () => {
            this.changeTextInForm();
          };
        });

        this.setDefaultTextProperties();
        this.openTextEditContainer(text);
      }
    });
  }

  pointerDown = (event: PointerEvent) => {
    event.stopPropagation();
    this.startX = event.clientX - this.currentSelectedText.offsetLeft;
    this.startY = event.clientY - this.currentSelectedText.offsetTop;

    this.previousPosition[this.currentSelectedText.getAttribute('id')!] = {
      x: this.currentSelectedText.offsetLeft,
      y: this.currentSelectedText.offsetTop
    };

    this.currentSelectedText.parentElement!.addEventListener(
      'pointermove',
      this.pointerMove
    );

    this.currentSelectedText.addEventListener(
      'pointerup',
      this.pointerUp
    );

    const horizontalClip = document.getElementById(
      `horizontal-clip-${this.horizontalSwiper.activeIndex}`
    ) as HTMLElement;

    this.centerGuidedLine = horizontalClip.offsetWidth / 2;
  }

  pointerMove = (event: PointerEvent) => {
    event.stopPropagation();

    let newLeft = event.clientX - this.startX;
    let newTop = event.clientY - this.startY;

    const imageWidth = this.currentSelectedText.parentElement!.offsetWidth;
    const imageHeight = this.currentSelectedText.parentElement!.offsetHeight;

    const maxLeft = imageWidth - this.currentSelectedText.offsetWidth;
    const maxTop = imageHeight - this.currentSelectedText.offsetHeight;

    newLeft = Math.max(0, Math.min(newLeft, maxLeft));
    newTop = Math.max(0, Math.min(newTop, maxTop));

    this.renderer.setStyle(this.currentSelectedText, 'left', `${newLeft}px`);
    this.renderer.setStyle(this.currentSelectedText, 'top', `${newTop}px`);

    const textLeft = this.currentSelectedText.offsetLeft + this.currentSelectedText.offsetWidth / 2;
    if (Math.abs(this.centerGuidedLine - textLeft) <= 10) {
      this.renderer.setStyle(
        this.currentSelectedText,
        'left',
        `${this.centerGuidedLine - this.currentSelectedText.offsetWidth / 2}px`
      );
      this.renderer.setStyle(this.centralGuidedLine.nativeElement, 'display', 'block');
    } else {
      this.renderer.setStyle(this.centralGuidedLine.nativeElement, 'display', 'none');
    }
  }

  pointerUp = (event: PointerEvent) => {
    event.stopPropagation();
    if (!this.currentSelectedText) return;

    const previousPosition = this.previousPosition[this.currentSelectedText.id];
    if (this.currentSelectedText.offsetLeft !== previousPosition.x || this.currentSelectedText.offsetTop !== previousPosition.y) {
      this.addNewAction("element", "move", [
        this.currentSelectedText.getAttribute("id"),
        this.previousPosition[this.currentSelectedText.getAttribute("id")],
        { x: this.currentSelectedText.offsetLeft, y: this.currentSelectedText.offsetTop }
      ]);
    }

    this.currentSelectedText.removeEventListener('pointerup', this.pointerUp);
    this.currentSelectedText.removeEventListener('pointerdown', this.pointerDown);
    this.currentSelectedText.parentElement.removeEventListener('pointermove', this.pointerMove);

    this.renderer.setStyle(this.centralGuidedLine.nativeElement, 'display', 'none');
  }

  setDefaultTextProperties(): any {
    if (this.defaultTextPropertiesContainer) {
      this.defaultTextPropertiesContainer.nativeElement.innerHTML = '';
      const currentClip = document.getElementById(`horizontal-clip-${this.horizontalSwiper.activeIndex}`);
      currentClip?.querySelectorAll('.clip-text:not(.user-image)').forEach((text, i) => {
        const p = document.createElement('p');
        p.innerHTML = text.getAttribute('data-name') || '';
        const textArea = document.createElement('textarea');
        textArea.classList.add('clip-text-area');
        textArea.id = `textarea-${i}`;
        textArea.placeholder = 'Click here to edit text...';
        textArea.cols = 30;
        textArea.rows = 3;
        textArea.value = text.textContent || '';

        this.defaultTextPropertiesContainer.nativeElement.append(p, textArea);
        textArea.addEventListener('click', () => this.openTextEditContainer(textArea, 'textarea'));
      });
    }
  }

  duplicateText(event: MouseEvent): any {
    event.stopPropagation();

    const previousText = this.currentSelectedText;
    if (this.currentSelectedText) {
      if (this.currentSelectedText.classList.contains('user-image')) {
        this.addImageInClip(this.currentSelectedText.querySelector('img')!.src);
      } else {
        this.addEle('text', this.currentSelectedText.innerText);
      }

      const horizontalText = this.currentSelectedText;
      horizontalText.style.top = previousText!.offsetTop + 5 + 'px';
      horizontalText.style.left = previousText!.offsetLeft + 5 + 'px';
      horizontalText.style.color = previousText!.style.color;
      horizontalText.style.fontSize = previousText!.style.fontSize;
      horizontalText.style.fontFamily = previousText!.style.fontFamily;
      horizontalText.style.fontStyle = previousText!.style.fontStyle;
      horizontalText.style.textAlign = previousText!.style.textAlign;

      if (!previousText!.dataset.name.includes('Added')) {
        horizontalText.dataset.duplicate = previousText!.dataset.duplicate || previousText!.dataset.name;
      }

      const verticalTextId = previousText!.id.replace('horizontal', 'vertical');
      const previousVerticalText = document.getElementById(verticalTextId);
      const verticalText = document.getElementById(this.currentSelectedText.id.replace('horizontal', 'vertical'));
      if (verticalText) {
        verticalText.style.top = previousVerticalText!.offsetTop + 2 + 'px';
        verticalText.style.left = previousVerticalText!.offsetLeft + 2 + 'px';
        verticalText.style.color = previousVerticalText!.style.color;
        verticalText.style.fontSize = previousVerticalText!.style.fontSize;
        verticalText.style.fontFamily = previousVerticalText!.style.fontFamily;
        verticalText.style.fontStyle = previousVerticalText!.style.fontStyle;
        verticalText.style.textAlign = previousVerticalText!.style.textAlign;
      }
    }
  }


  deleteText(event: MouseEvent) {
    event.stopPropagation();
    if (this.currentSelectedText) {
      this.currentSelectedText.remove();
      this.currentSelectedText = null;
      this.resetWorkspaceView();
    }
  }
  // increaseSizeByDrag(ele: HTMLElement, currentClip: HTMLElement): void {
  //   let startX: number, startWidth: number, startFontSize: number;
  //   const element = ele.closest('.clip-text') as HTMLElement;
  //   const parentWidth = currentClip.offsetWidth;
  //   const textLeft = element.offsetLeft;

  //   const elementId = element.getAttribute("id")!;
  //   const previousLeft: { [key: string]: string } = {};
  //   const previousFontSizes: { [key: string]: string } = {};

  //   previousLeft[elementId] = element.style.left;
  //   previousFontSizes[elementId] = element.style.fontSize;

  //   let maxWidth = parentWidth - textLeft;

  //   const startEvent = (event: PointerEvent) => {
  //     event.stopPropagation();
  //     event.preventDefault();
  //     startX = event.clientX;

  //     if (element.classList.contains('user-image')) {
  //       startWidth = element.children[0].clientWidth;
  //       maxWidth = maxWidth - 10;
  //       document.addEventListener('pointermove', handleResizeImage);
  //     } else {
  //       startWidth = element.clientWidth;
  //       startFontSize = parseFloat(window.getComputedStyle(element).fontSize);
  //       document.addEventListener('pointermove', handleResize);
  //     }
  //     document.addEventListener('pointerup', stopResize);
  //   };

  //   const handleResize = (event: PointerEvent) => {
  //     const deltaX = event.clientX - startX;
  //     const newWidth = startWidth + deltaX;
  //     const minWidth = 50;
  //     const clampedWidth = Math.max(minWidth, Math.min(newWidth, maxWidth));
  //     const newFontSize = (clampedWidth / startWidth) * startFontSize;

  //     this.renderer.setStyle(element, 'fontSize', `${newFontSize}px`);
  //     const fontSizeContainer = document.querySelector('.font-size-container .value');
  //     if (fontSizeContainer) {
  //       fontSizeContainer.innerHTML = newFontSize.toFixed(2);
  //     }
  //   };

  //   const handleResizeImage = (event: PointerEvent) => {
  //     const deltaX = event.clientX - startX;
  //     const newWidth = startWidth + deltaX;
  //     const minWidth = 50;
  //     const clampedWidth = Math.max(minWidth, Math.min(newWidth, maxWidth));

  //     const imageElement = element.querySelector('img') as HTMLImageElement;
  //     if (imageElement) {
  //       this.renderer.setStyle(imageElement, 'width', `${clampedWidth}px`);
  //     }
  //   };

  //   const stopResize = () => {
  //     if (previousFontSizes[elementId] !== element.style.fontSize) {
  //       this.addNewAction("element", "scale", [
  //         elementId,
  //         previousFontSizes[elementId],
  //         element.style.fontSize
  //       ]);
  //     }
  //     document.removeEventListener('pointermove', handleResize);
  //     document.removeEventListener('pointermove', handleResizeImage);
  //     document.removeEventListener('pointerup', stopResize);
  //   };

  //   startEvent(new PointerEvent('pointerdown'));
  // }

  increaseSizeByDrag(event: Event, ele: HTMLElement, currentClip: HTMLElement): void {
    let startX: number, startWidth: number, startFontSize: number;
    let element = ele.closest('.clip-text') as HTMLElement;
    let parentWidth = currentClip.offsetWidth;
    let textLeft = element.offsetLeft;
    this.previousLeft[element.getAttribute('id')!] = element.style.left;
    this.previousFontSizes[element.getAttribute('id')!] = element.style.fontSize;
    let maxWidth = parentWidth - textLeft;

    event.stopPropagation();
    event.preventDefault();
    startX = (event as PointerEvent).clientX;
    const handleResize = (e: PointerEvent): void => {
      const deltaX = e.clientX - startX;
      const newWidth = startWidth + deltaX;
      const minWidth = 50;
      const clampedWidth = Math.max(minWidth, Math.min(newWidth, maxWidth));
      const newFontSize = (clampedWidth / startWidth) * startFontSize;
      this.renderer.setStyle(element, 'font-size', `${newFontSize}px`);
      (document.querySelector('.font-size-container .value') as HTMLElement).innerHTML = newFontSize.toFixed(2);
    };

    const handleResizeImage = (e: PointerEvent): void => {
      const deltaX = e.clientX - startX;
      const newWidth = startWidth + deltaX;
      const minWidth = 50;
      const clampedWidth = Math.max(minWidth, Math.min(newWidth, maxWidth));
      this.renderer.setStyle(element.querySelector('img'), 'width', `${clampedWidth}px`);
    };

    const stopResize = (): void => {
      if (this.previousFontSizes[element.getAttribute('id')!] !== element.style.fontSize) {
        this.addNewAction(
          'element',
          'scale',
          [
            element.getAttribute('id'),
            this.previousFontSizes[element.getAttribute('id')!],
            element.style.fontSize
          ]
        );
      }
      document.removeEventListener('pointermove', handleResize);
      document.removeEventListener('pointermove', handleResizeImage);
      document.removeEventListener('pointerup', stopResize);
    };
    if (element.classList.contains('user-image')) {
      document.addEventListener('pointermove', handleResizeImage);
      startWidth = element.children[0].clientWidth;
      maxWidth = maxWidth - 10;
    } else {
      startWidth = element.clientWidth;
      startFontSize = parseFloat(window.getComputedStyle(element).fontSize);
      document.addEventListener('pointermove', handleResize);
    }

    document.addEventListener('pointerup', stopResize);
  }



  openTextEditMobileModal(): void {
    // const modal = document.querySelector('.mobile-edit-text-modal') as HTMLElement;
    // const textArea = document.querySelector('.mobile-edit-text-modal textarea') as HTMLTextAreaElement;
    // if (modal && textArea && this.currentSelectedText) {
    //   modal.style.display = 'flex';
    //   const textElement = this.currentSelectedText.querySelector('.text');
    //   if (textElement) {
    //     textArea.value = textElement.textContent || '';
    //   }
    // }
    (document.querySelector('.mobile-edit-text-modal') as HTMLElement).style.display = 'flex';
    (document.querySelector('.mobile-edit-text-modal textarea') as HTMLInputElement).value = this.currentSelectedText.querySelector('.text').innerText;
  }

  openMobileDropdown(selector: string, event: Event): void {
    let ele = event.currentTarget as HTMLElement;
    const dropdownEle = document.querySelector(`.${selector}`) as HTMLElement;
    const propertiesContainer = document.querySelector('.bottom-properties-container .properties') as HTMLElement;
    const titleContainer = document.querySelector('.bottom-properties-container .title-container') as HTMLElement;

    if (!this.currentOpenedModal) {
      propertiesContainer.style.display = 'none';
      titleContainer.style.display = 'flex';
    } else {
      if (this.currentOpenedModal instanceof HTMLElement) {
        this.currentOpenedModal.classList.remove('open');
      }
      if (this.previousSelectedTitleEle instanceof HTMLElement) {
        this.previousSelectedTitleEle.classList.remove('active');
      }
      this.currentOpenedModal = null;
      this.previousSelectedTitleEle = null;
    }

    this.currentOpenedModal = dropdownEle;
    this.previousSelectedTitleEle = ele;

    dropdownEle.classList.add('open');
    ele.classList.add('active');
  }

  // updateTextFromMobileEdit(): void {
  //   const modal = document.querySelector('.mobile-edit-text-modal') as HTMLElement;
  //   const textArea = document.querySelector('.mobile-edit-text-modal textarea') as HTMLTextAreaElement;
  //   if (this.currentSelectedText && textArea) {
  //     const textElement = this.currentSelectedText.querySelector('.text');
  //     if (textElement) {
  //       textElement.textContent = textArea.value;
  //     }
  //     modal.style.display = 'none';
  //   }
  // }

  updateTextFromMobileEdit(): void {
    this.currentSelectedText.querySelector('.text').innerText = (document.querySelector('.mobile-edit-text-modal textarea') as HTMLInputElement).value;
    (document.querySelector('.mobile-edit-text-modal') as HTMLElement).style.display = 'none';
  }

  async openTextEditContainer(ele: HTMLElement, elementType: string = 'div'): Promise<void> {
    const defaultTextPropertiesContainer = document.querySelector('.text-display-container') as HTMLElement;
    const textEditContainer = document.querySelector('.text-editing-container') as HTMLElement;
    const fontWeightDropdown = document.querySelector('.font-style-dropdown') as HTMLElement;

    defaultTextPropertiesContainer.style.display = 'none';
    if (window.innerWidth > 576) textEditContainer.style.display = 'block';

    const selectedText = document.getElementById(
      ele.id.replace('textarea', `horizontalclip-${this.horizontalSwiper.activeIndex}-text`)
    ) as HTMLElement;

    if (elementType === 'textarea') {
      this.resetTextDecorationToDefault();
      selectedText.click();
    }

    (textEditContainer.querySelector('textarea') as HTMLTextAreaElement).value = ele.innerText;
    document.querySelector('.font-family-container .data-family')!.innerHTML = selectedText.style.fontFamily.replaceAll('"', '');
    fontWeightDropdown.innerHTML = '';

    this.fontData[selectedText.style.fontFamily.replaceAll('"', '')].forEach((weight: string) => {
      const fontWeight = this.renderer.createElement('p');
      this.renderer.setAttribute(fontWeight, 'data-weight', weight);
      this.renderer.setProperty(fontWeight, 'innerHTML', weight);
      fontWeightDropdown.appendChild(fontWeight);
    });

    this.handleFontWeight('', document.querySelector('.font-style-container')!, selectedText.getAttribute('font-style'));

    (document.querySelector('.font-color-container .data-color') as HTMLElement).style.backgroundColor = selectedText.style.color;
    document.querySelector('.font-size-container .data-size')!.innerHTML = parseFloat(selectedText.style.fontSize).toFixed(2);
    document.querySelector('.font-lineheight-dropdown .value')!.innerHTML = parseFloat(selectedText.style.lineHeight).toString();
    (document.querySelector('.font-lineheight-dropdown input') as HTMLInputElement).value = parseFloat(selectedText.style.lineHeight).toString();

    // const animation = selectedText.getAttribute('start-animation');
    // document.querySelector('.text-animation-container .data-animation')!.innerHTML =
    //   animation !== 'null' && animation ? animation : 'Select Animation';

    // document.querySelectorAll('.text-animation-dropdown p, .mobile-textanimation-display p')
    //   .forEach((el) => {
    //     el.classList.remove('active');
    //   });

    // document.querySelectorAll(`.text-animation-dropdown p[data-animation="${animation}"], .mobile-textanimation-display p[data-animation="${animation}"]`).forEach((el) => {
    //   el.classList.add('active');
    // });
  }


  closeTextEditContainer(event: Event): any {
    let ele = event.currentTarget as HTMLElement;
    event?.stopPropagation();
    if (window.innerWidth > 576 && this.defaultTextPropertiesContainer) {
      this.defaultTextPropertiesContainer.nativeElement.style.display = 'block';
    }
    ele.parentElement!.style.display = 'none';
  }

  openDropDown(event: Event, subType: number): void {
    let ele = event.currentTarget as HTMLElement;
    const dropdown = ele.querySelector('div');
    const icon = ele.querySelector('i');
    if (dropdown?.classList.contains('open')) {
      icon?.classList.replace('fa-angle-up', 'fa-angle-down');
    } else {
      icon?.classList.replace('fa-angle-down', 'fa-angle-up');
    }
    dropdown?.classList.toggle('open');
    if (subType == 1)
      this.handleFontFamily(event)
    if (subType == 2)
      this.handleTextAlignment(event)
    if (subType == 3)
      this.handleAnimation(event);
    if (subType == 4)
      this.handleFontColor(event);
    if (subType == 5)
      this.handleFontWeight(event, event.currentTarget as HTMLElement);
    if (subType == 6)
      this.handleFontSize(event, event.currentTarget as HTMLElement);
  }

  resetTextDecorationToDefault = () => {
    if (this.currentSelectedText) {
      this.currentSelectedText.querySelector('.active-border')?.remove();
      this.currentSelectedText.querySelector('.active-option')?.remove();
      this.currentSelectedText.classList.remove('active');
      if (!this.currentSelectedText.classList.contains('user-image')) {
        this.currentSelectedText.querySelector('.text')!.setAttribute('contentEditable', 'false');
      }
      this.currentSelectedText.removeEventListener('pointerup', this.pointerUp);
      this.currentSelectedText.removeEventListener('pointerdown', this.pointerDown);
      this.currentSelectedText.parentElement?.removeEventListener('pointermove', this.pointerMove);
      this.currentSelectedText.parentElement?.removeEventListener('pointerdown', this.resetTextDecorationToDefault);
      this.currentSelectedText = null;
    }
    this.resetWorkspaceView();
  }

  resetWorkspaceView(): void {
    if (this.currentOpenedModal) {
      this.currentOpenedModal.classList.remove('open');
      this.currentOpenedModal = null;
    }
    this.textEditContainer.nativeElement.style.display = 'none';
    this.addEleContainer.nativeElement.style.display = 'none';
    this.mobileAddEleContainer.nativeElement.style.display = 'none';
    this.imageOptionContainer.nativeElement.style.display = 'none';

    if (window.innerWidth < 576) {
      this.horizontalSwiper.enable()
      document.querySelector<HTMLElement>('.bottom-properties-container .title-container')!.style.display = 'none';
      document.querySelector<HTMLElement>('.bottom-properties-container')!.style.display = 'none';
      document.querySelector<HTMLElement>('.text-properties-container')!.style.display = 'block';
    }

    if (window.innerWidth > 576 && this.defaultTextPropertiesContainer) {
      this.defaultTextPropertiesContainer.nativeElement.style.display = 'block';
    }
  }

  changeTextInForm(): void {
    const textArea = document.getElementById('text-area-0') as HTMLTextAreaElement;
    if (textArea && this.currentSelectedText) {
      const textElement = this.currentSelectedText.querySelector('.text') as HTMLElement;
      textArea.value = textElement.innerText;
    }
  }

  changeTextInWorkspace = () => {
    const textArea = document.getElementById('text-area-0') as HTMLTextAreaElement;
    if (textArea && this.currentSelectedText) {
      const textElement = this.currentSelectedText.querySelector('.text') as HTMLElement;
      textElement.innerText = textArea.value;
    }
  }

  addFontSize(): void {
    for (let i = 2; i <= 90; i += 2) {
      const fontSize = document.createElement('p');
      fontSize.setAttribute('data-size', i.toString());
      fontSize.innerHTML = i.toString();
      this.fontSizeDropdown.nativeElement.append(fontSize);
    }
  }

  addFontStyling(language: string = 'english'): void {
    if (language === 'english') {
      this.fontData = this.sortFontsByName(this.customFonts);
    }
    else if (language === 'hindi') {
      this.fontData = this.customFonts_Hindi;
    }
    else if (language === 'tamil') {
      this.fontData = this.customFonts_Tamil;
    }
    else if (language === 'marathi') {
      this.fontData = this.customFonts_Marathi;
    }
    else if (language === 'telugu') {
      this.fontData = this.customFonts_Telugu;
    }
    else if (language === 'gujarati') {
      this.fontData = this.customFonts_Gujarati;
    }
    else if (language === 'arabic') {
      this.fontData = this.customFonts_Arabic;
    }
    else if (language === 'kannada') {
      this.fontData = this.customFonts_Kannada;
    }
    else {
      this.fontData = this.customFonts[`customFonts_${language}`];
    }
    let container: HTMLElement;
    if (window.innerWidth > 576) {
      container = this.fontFamilyDropdown.nativeElement;
    } else {
      container = this.mobileFontFamily.nativeElement;
    }
    container.innerHTML = '';
    for (const font in this.fontData) {
      const fontName = document.createElement('p');
      fontName.setAttribute('data-family', font);
      fontName.style.fontFamily = font;
      fontName.innerHTML = font;
      container.append(fontName);
    }
  }

  addColors(): void {
    const allColors = ["#FF0000", "#FF8000", "#FFFF00", "#80FF00", "#00FF00", "#00FFFF", "#0080FF", "#7F00FF", "#FF00FF", "#FF007F", "#808080"];
    const colors: any[] = [];

    allColors.map(el => {
      let color = new (Values as any)(el);
      color = color.all(28);
      color.splice(6, 1);
      colors.push(...color);
    });

    colors.forEach(color => {
      const colorCode = this.getHex(color.rgb[0], color.rgb[1], color.rgb[2]);
      const fontColor = document.createElement('p');
      fontColor.setAttribute('data-color', colorCode);
      fontColor.classList.add('color-options');
      fontColor.style.backgroundColor = colorCode;
      this.fontColorDropdown.nativeElement.querySelector('.color-shades')?.append(fontColor.cloneNode(true));
      this.mobileFontColor.nativeElement.append(fontColor.cloneNode(true));
    });
  }

  handleFontSize(event: Event, ele: HTMLElement): void {
    const target = event.target as HTMLElement;
    const selectedFontSize = target.dataset['size'];

    if (!selectedFontSize || !this.currentSelectedText) return;

    this.addNewAction(
      "element",
      "size",
      [
        this.currentSelectedText.getAttribute("id"),
        this.currentSelectedText.style.fontSize,
        `${selectedFontSize}px`
      ]
    );

    this.currentSelectedText.style.fontSize = `${selectedFontSize}px`;
    ele.querySelector('p .data-size')!.innerHTML = selectedFontSize;

    ele.querySelectorAll('.font-size-dropdown p').forEach((ele) => {
      ele.classList.remove('active');
    });

    target.classList.add('active');
  }

  handleMobileFontSize(event: Event): void {
    let ele = event.currentTarget as HTMLInputElement;
    if (this.currentSelectedText) {
      this.currentSelectedText.style.fontSize = `${ele.value}px`;
      const sliderValue = document.querySelector('.mobile-fontsize-value .font-slider-value') as HTMLElement;
      if (sliderValue) {
        sliderValue.innerHTML = ele.value;
      }
    }
  }

  handleClickMobileFontsize(event: Event, value: number): void {
    event?.stopPropagation();
    if (this.currentSelectedText) {
      const fontSize = Math.max(5, Math.min(50, parseInt(this.currentSelectedText.style.fontSize) + value));
      this.currentSelectedText.style.fontSize = `${fontSize}px`;
      const mobileFontSlide = document.getElementById('mobile-font-slide') as HTMLInputElement;
      if (mobileFontSlide) {
        mobileFontSlide.value = fontSize.toString();
      }
      const sliderValue = document.querySelector('.mobile-fontsize-value .font-slider-value') as HTMLElement;
      if (sliderValue) {
        sliderValue.innerHTML = fontSize.toString();
      }
    }
  }

  handleFontColor(event: Event, type: string = ''): void {

    let selectedFontColor: string | undefined;
    let ele = event.currentTarget as HTMLInputElement;
    if (type === 'input') {
      selectedFontColor = ele.value;
    } else {
      const target = event.target as HTMLElement;
      selectedFontColor = target.dataset['color'];
    }

    if (!selectedFontColor || !this.currentSelectedText) return;

    document.querySelectorAll('.font-color-container p .data-color, .mobile-fontcolor-value p .data-color')
      .forEach((ele) => {
        (ele as HTMLElement).style.backgroundColor = selectedFontColor!;
      });
    this.addNewAction("element", "color", [this.currentSelectedText.getAttribute("id"), this.currentSelectedText.style.color, selectedFontColor]);
    this.currentSelectedText.style.color = selectedFontColor!;
  }

  displaySelectedColor(event: Event): void {
    let ele = event.currentTarget as HTMLInputElement;
    const selectedFontColor = ele.value;
    if (selectedFontColor && this.currentSelectedText) {
      this.currentSelectedText.style.color = selectedFontColor;
    }
  }

  // handleFontFamily(event: Event): void {
  //   const target = event.target as HTMLElement;
  //   const ele = event.target as HTMLElement;
  //   const selectedFontFamily = target.dataset['family'];
  //   if (!selectedFontFamily || !this.currentSelectedText) return;

  //   let weightContainer: HTMLElement | undefined;
  //   if (window.innerWidth > 576) {
  //     weightContainer = this.fontWeightDropdown.nativeElement;
  //   } else {
  //     weightContainer = this.mobileFontWeight.nativeElement;
  //   }

  //   this.currentSelectedText.style.fontFamily = `'${selectedFontFamily}'`;
  //   ele.querySelector('p .data-family')!.innerHTML = selectedFontFamily;

  //   ele.querySelectorAll('.font-family-dropdown p, .mobile-fontfamily-display p')
  //     .forEach((ele) => {
  //       ele.classList.remove('active');
  //     });

  //   weightContainer.innerHTML = '';
  //   (window['fontData'][selectedFontFamily] as string[]).forEach((weight) => {
  //     const fontWeight = document.createElement('p');
  //     fontWeight.setAttribute('data-weight', weight);
  //     fontWeight.innerHTML = weight;
  //     weightContainer.append(fontWeight);
  //     if (weight === 'Regular') fontWeight.classList.add('active');
  //   });

  //   target.classList.add('active');
  // }
  handleFontFamily(event: Event): void {
    const target = event.target as HTMLElement;
    let ele = event.currentTarget as HTMLElement;
    const selectedFontFamily = target.dataset['family'];

    if (!selectedFontFamily) return;

    let weightContainer: HTMLElement | undefined;

    if (this.windowWidth > 576) {
      weightContainer = this.fontWeightDropdown.nativeElement;
    } else {
      weightContainer = this.mobileFontWeight.nativeElement;
    }

    this.addNewAction(
      'element',
      'family',
      [
        this.currentSelectedText.getAttribute('id'),
        this.currentSelectedText.style.fontFamily,
        this.currentSelectedText.getAttribute('font-style'),
        selectedFontFamily,
        'Regular'
      ]
    );

    this.renderer.setStyle(
      this.currentSelectedText,
      'font-family',
      `'${selectedFontFamily}'`
    );

    const familyText = ele.querySelector('p .data-family') as HTMLElement;
    if (familyText) {
      familyText.innerHTML = selectedFontFamily;
    }

    const fontElements = ele.querySelectorAll('.font-family-dropdown p, .mobile-fontfamily-display p');
    fontElements.forEach((element) => {
      this.renderer.removeClass(element, 'active');
    });

    weightContainer.innerHTML = '';

    this.fontData[selectedFontFamily].forEach((weight) => {
      const fontWeight = this.renderer.createElement('p');
      this.renderer.setAttribute(fontWeight, 'data-weight', weight);

      if (weight === 'Regular') {
        this.renderer.addClass(fontWeight, 'active');
      }
      fontWeight.innerHTML = weight;
      this.renderer.appendChild(weightContainer, fontWeight);
    });

    this.renderer.addClass(target, 'active');

    this.handleFontWeight('',
      document.querySelector('.font-style-container') as HTMLElement,
      'Regular');
  }

  handleFontWeight(event: any, ele: HTMLElement, weight: string | null = null): void {
    let selectedFontWeight: string | undefined;
    const target = event.target as HTMLElement;

    if (weight) {
      selectedFontWeight = weight;
    } else {
      selectedFontWeight = target.dataset['weight'];
    }

    if (!selectedFontWeight || !this.currentSelectedText) return;

    const [fontWeight, fontStyle] = this.fontWeightMap[selectedFontWeight];
    this.currentSelectedText.style.fontWeight = fontWeight;
    this.currentSelectedText.style.fontStyle = fontStyle;
    this.currentSelectedText.setAttribute('font-style', selectedFontWeight);

    ele.querySelectorAll('.font-family-dropdown p, .mobile-fontweight-dropdown p, .font-style-dropdown p')
      .forEach((ele) => {
        ele.classList.remove('active');
      });

    if (weight) {
      ele.querySelector('p .data-weight')!.innerHTML = weight;
      document.querySelector(`.font-style-dropdown p[data-weight="${weight}"]`)!.classList.add('active');
    } else {
      ele.querySelector('p .data-weight')!.innerHTML = target.innerHTML;
      target.classList.add('active');
    }
  }

  handleTextAlignment(event: Event): void {
    const target = event.target as HTMLElement;
    const ele = event.currentTarget as HTMLElement;
    const selectedTextAlign = target.dataset['align'];
    if (!selectedTextAlign || !this.currentSelectedText) return;

    this.currentSelectedText.style.textAlign = selectedTextAlign;

    ele.querySelectorAll('.font-alignment-dropdown p, div > p')
      .forEach((ele) => {
        ele.classList.remove('active');
      });

    target.querySelector('p')!.classList.add('active');
  }

  handleLineHeight(event: Event): void {
    let ele = event.currentTarget as HTMLInputElement;
    if (this.currentSelectedText) {
      this.currentSelectedText.style.lineHeight = ele.value;
      ele.parentElement!.querySelector('.value')!.innerHTML = ele.value;
    }
  }

  handleAnimation(event: Event): void {
    const target = event.target as HTMLElement;
    const ele = event.currentTarget as HTMLElement;
    const selectedTextAnimation = target.parentElement!.dataset['animation'];
    if (!selectedTextAnimation || !this.currentSelectedText) return;

    if (target.tagName.toLowerCase() === 'i') {
      const previewModal = document.querySelector('.animation-preview-modal') as HTMLElement;
      const previewImage = document.querySelector('.animation-gif img') as HTMLImageElement;
      previewModal.style.display = 'flex';
      previewImage.src = `./assets/animations/text/${selectedTextAnimation}.gif`;
      return;
    }

    this.currentSelectedText.setAttribute('start-animation', selectedTextAnimation === 'null' ? '' : selectedTextAnimation);

    ele.querySelectorAll('.text-animation-dropdown p, .mobile-textanimation-display p')
      .forEach((ele) => {
        ele.classList.remove('active');
      });

    target.classList.add('active');
    ele.querySelector('p .data-animation')!.innerHTML = selectedTextAnimation === 'null' ? 'Select Animation' : selectedTextAnimation;
  }

  handleClickMobileLineheight(value: number, event: Event): void {
    event.stopPropagation();

    if (this.currentSelectedText) {
      const lineHeight = Math.max(
        0.5,
        Math.min(
          3,
          parseFloat(this.currentSelectedText.style.lineHeight) + value
        )
      ).toFixed(2);

      this.currentSelectedText.style.lineHeight = lineHeight;

      const mobileLineheightSlide = document.getElementById(
        'mobile-lineheight-slide'
      ) as HTMLInputElement;

      if (mobileLineheightSlide) {
        mobileLineheightSlide.value = lineHeight;
      }

      const fontSliderValue = document.querySelector(
        '.mobile-fontlineheight-value .font-slider-value'
      ) as HTMLElement;

      if (fontSliderValue) {
        fontSliderValue.innerHTML = lineHeight;
      }
    }
  }


  handleMobileLineheight(event: Event): void {
    let ele = event.currentTarget as HTMLInputElement;
    if (this.currentSelectedText) {
      this.currentSelectedText.style.lineHeight = ele.value;
      const sliderValue = document.querySelector('.mobile-fontlineheight-value .font-slider-value') as HTMLElement;
      sliderValue.innerHTML = ele.value;
    }
  }

  openAddEleContainer(): void {
    this.defaultTextPropertiesContainer.nativeElement.style.display = 'none';
    this.textEditContainer.nativeElement.style.display = 'none';
    this.imageOptionContainer.nativeElement.style.display = 'none';

    if (window.innerWidth > 576) {
      this.addEleContainer.nativeElement.style.display = 'block';
    } else {
      const mobileContainerStyle = getComputedStyle(this.mobileAddEleContainer.nativeElement);
      if (mobileContainerStyle.display === 'none') {
        this.mobileAddEleContainer.nativeElement.style.display = 'flex';
      } else {
        this.mobileAddEleContainer.nativeElement.style.display = 'none';
      }
    }
  }

  addEle(type: string, defaultText: string = 'New Text', textTitle: string = 'Added Text'): any {
    const horizontalClip = document.getElementById(`horizontal-clip-${this.horizontalSwiper.activeIndex}`) as HTMLElement;
    const totalText = horizontalClip.querySelectorAll('.clip-text').length;
    const verticalClip = document.getElementById(`vertical-clip-${this.horizontalSwiper.activeIndex}`) as HTMLElement;

    if (type === 'image') {
      this.imageOptionContainer.nativeElement.style.display = 'block';
      this.addEleContainer.nativeElement.style.display = 'none';
      this.mobileAddEleContainer.nativeElement.style.display = 'none';
      return;
    }

    const textContainer = document.createElement('div');
    const text = document.createElement('p');
    text.innerHTML = defaultText;
    text.classList.add('text');
    textContainer.classList.add('clip-text');
    textContainer.setAttribute('data-name', textTitle);
    textContainer.setAttribute('id', `horizontalclip-${this.horizontalSwiper.activeIndex}-text-${totalText}`);
    textContainer.setAttribute('font-style', 'Regular');

    Object.assign(textContainer.style, {
      top: '45%',
      left: `${horizontalClip.offsetWidth * 0.1}px`,
      fontSize: '20px',
      fontFamily: 'Arial',
      fontStyle: 'Regular',
      color: '#000000',
      textAlign: 'center',
      lineHeight: '1',
      width: 'max-content'
    });

    textContainer.append(text);
    this.addTextEventListeners(textContainer);
    horizontalClip.append(textContainer);

    const verticalText = textContainer.cloneNode(true) as HTMLElement;
    verticalText.style.fontSize = '5px';
    verticalText.setAttribute('id', `verticalclip-${this.horizontalSwiper.activeIndex}-text-${totalText}`);
    verticalClip.append(verticalText);

    textContainer.click();
    this.resetWorkspaceView();

    if (window.innerWidth < 576) {
      this.horizontalSwiper.disable();
    }
  }


  addImageInClip(link: string): any {
    const horizontalClip = document.getElementById(`horizontal-clip-${this.horizontalSwiper.activeIndex}`) as HTMLElement;
    const totalText = horizontalClip.querySelectorAll('.clip-text').length;
    const verticalClip = document.getElementById(`vertical-clip-${this.horizontalSwiper.activeIndex}`) as HTMLElement;

    const container = this.renderer.createElement('div');
    this.renderer.addClass(container, 'clip-text');
    this.renderer.addClass(container, 'user-image');
    this.renderer.setAttribute(container, 'id', `horizontalclip-${this.horizontalSwiper.activeIndex}-image-${totalText}`);
    this.renderer.setStyle(container, 'position', 'absolute');
    this.renderer.setStyle(container, 'left', `${horizontalClip.offsetWidth * 0.4}px`);
    this.renderer.setStyle(container, 'top', '45%');
    this.renderer.setStyle(container, 'z-index', '2');
    this.renderer.setStyle(container, 'userSelect', 'none');

    const img = this.renderer.createElement('img');
    img.src = link;
    this.renderer.setStyle(img, 'height', 'auto');
    this.renderer.setStyle(img, 'width', `${horizontalClip.offsetWidth * 0.20}px`);
    this.renderer.appendChild(container, img);

    this.renderer.appendChild(horizontalClip, container);
    this.addTextEventListeners(container);

    const verticalImage = container.cloneNode(true) as HTMLElement;
    this.renderer.setStyle(verticalImage, 'left', `${verticalClip.offsetWidth * 0.4}px`);
    const verticalImageElement = verticalImage.querySelector('img') as HTMLImageElement;
    this.renderer.setStyle(verticalImageElement, 'width', `${verticalClip.offsetWidth * 0.20}px`);
    this.renderer.setAttribute(verticalImage, 'id', `verticalclip-${this.horizontalSwiper.activeIndex}-image-${totalText}`);

    this.renderer.appendChild(verticalClip, verticalImage);
    (container as HTMLElement).click();
    this.resetWorkspaceView();
  }

  closeModal(event: Event, editImageModal: boolean = false, isParentElement: boolean = false): void {
    if (this.isShowPreviewStatus) {
      this.toastr.warning(
        'Video generation is in progress. Please stay with us.'
      );
      event.preventDefault();
      return;
    }
    let ele = event.currentTarget as HTMLElement;
    if (editImageModal) {
      this.cropper.destroy();
      this.imageInput.nativeElement.value = '';
      this.imageInputType = '';
    }
    this.renderer.setStyle(isParentElement ? ele.parentElement?.parentElement?.parentElement : ele.parentElement?.parentElement, 'display', 'none');
  }

  closeModalRearrange(event: Event): void {
    const target = (event.target as HTMLElement).closest('.rearrange-clips')?.querySelector('.close-btn') as HTMLElement;
    if (target) {
      target.click();
    }
  }

  closeMobileModal(ele: HTMLElement): void {
    event.stopPropagation();
    this.renderer.removeClass(ele.parentElement, 'open');
    this.currentOpenedModal = null;
  }

  generateRearrangeClipsContainer(parent: HTMLElement, clipDirection: string, i: number, clipData: any): any {
    let scale: number;
    const clipContainer = this.renderer.createElement('div');
    const elementsContainer = this.renderer.createElement('div');
    this.renderer.addClass(elementsContainer, 'rearrange-clip');
    this.renderer.setAttribute(elementsContainer, 'data-index', i.toString());
    this.renderer.setStyle(clipContainer, 'height', '130px');
    this.renderer.setStyle(clipContainer, 'width', 'auto');
    this.renderer.setStyle(clipContainer, 'aspectRatio', '9/16');
    this.renderer.setStyle(clipContainer, 'position', 'relative');
    this.renderer.setAttribute(clipContainer, 'id', `${clipDirection}-clip-${i}`);
    this.renderer.setAttribute(clipContainer, 'data-name', clipData.name);
    this.renderer.setAttribute(clipContainer, 'data-src', clipData.image);
    this.renderer.setAttribute(clipContainer, 'data-bufferStart', clipData['bufferStart']);
    this.renderer.setAttribute(clipContainer, 'data-bufferEnd', clipData['bufferEnd']);
    this.renderer.setAttribute(clipContainer, 'data-clipDuration', clipData['clipDuration']);
    scale = 130 / this.globalHeight;

    const optionsContainer = this.renderer.createElement('div');

    if (clipDirection === 'add') {
      const title = this.renderer.createElement('p');
      this.renderer.addClass(title, 'add-clip-number');
      title.innerHTML = `Add Clip ${i + 1}`;
      this.renderer.appendChild(optionsContainer, title);
      this.renderer.appendChild(elementsContainer, clipContainer);
      this.renderer.appendChild(elementsContainer, optionsContainer);

      this.renderer.listen(elementsContainer, 'click', (event: Event) => {
        const target = event.currentTarget as HTMLElement;
        this.addClip(target);
      });
    } else {
      const dragBtn = this.renderer.createElement('i');
      this.renderer.addClass(dragBtn, 'fa-solid');
      this.renderer.addClass(dragBtn, 'fa-bars');
      this.renderer.addClass(dragBtn, 'dragger');
      this.renderer.addClass(optionsContainer, 'options');
      const title = this.renderer.createElement('p');
      this.renderer.addClass(title, 'clip-number');
      title.innerHTML = `Clip ${i + 1}`;

      const duplicateBtn = this.renderer.createElement('i');
      this.renderer.addClass(duplicateBtn, 'fa-regular');
      this.renderer.addClass(duplicateBtn, 'fa-clone');
      this.renderer.listen(duplicateBtn, 'click', (event: Event) => {
        const target = event.currentTarget as HTMLElement;
        this.duplicateClip(target);
      });

      const removeBtn = this.renderer.createElement('i');
      this.renderer.addClass(removeBtn, 'fa-solid');
      this.renderer.addClass(removeBtn, 'fa-trash');
      this.renderer.listen(removeBtn, 'click', (event: Event) => {
        const target = event.currentTarget as HTMLElement;
        this.removeClip(target);
      });

      this.renderer.appendChild(optionsContainer, title);
      this.renderer.appendChild(optionsContainer, duplicateBtn);
      this.renderer.appendChild(optionsContainer, removeBtn);
      this.renderer.appendChild(elementsContainer, dragBtn);
      this.renderer.appendChild(elementsContainer, clipContainer);
      this.renderer.appendChild(elementsContainer, optionsContainer);
    }

    this.renderer.appendChild(parent, elementsContainer);
    return scale;
  }


  switchContainer(translate: string) {
    document.querySelectorAll('.rearrange, .add-clips')
      .forEach(ele => {
        ele.classList.toggle('active');
      });
    const container = document.querySelector('.rearrange-add-container') as HTMLElement;
    container.style.transform = `translateX(${translate})`;
  }

  openCustomizeClipsModal() {
    let userClipData = this.createData();
    userClipData = userClipData['clips'];
    this.rearrangeClipsContainer.nativeElement.innerHTML = '';

    for (let i = 0; i < userClipData.length; i++) {
      const scale = this.generateRearrangeClipsContainer(this.rearrangeClipsContainer.nativeElement, 'rearrange', i, userClipData[i]);
      this.setImageAndText(document.getElementById(`rearrange-clip-${i}`) as HTMLElement, scale, userClipData[i], 'rearrange', i);
    }
    (document.querySelector('.rearrange-container') as HTMLElement).style.display = 'flex';
  }

  duplicateClip = (ele: HTMLElement) => {
    if (!this.rearrangeClipsContainer) return;
    const clipLength = this.rearrangeClipsContainer.nativeElement.childElementCount;
    const clip = ele.closest('.rearrange-clip') as HTMLElement;
    const cloneClip = clip.cloneNode(true) as HTMLElement;

    cloneClip.setAttribute('data-index', clipLength.toString());
    cloneClip.querySelector('.clip-number')!.innerHTML = `Clip ${clipLength + 1}`;
    cloneClip.querySelector('div:not(.options)')!.setAttribute('id', `rearrange-clip-${clipLength}`);
    cloneClip.querySelector('.fa-clone')!.addEventListener('click', () => this.duplicateClip(cloneClip));
    cloneClip.querySelector('.fa-trash')!.addEventListener('click', () => this.removeClip(cloneClip));

    this.rearrangeClipsContainer.nativeElement.append(cloneClip);
  }

  removeClip = (ele: HTMLElement) => {
    if (!this.rearrangeClipsContainer) return;
    const clip = ele.closest('.rearrange-clip') as HTMLElement;
    clip.remove();

    Array.from(this.rearrangeClipsContainer.nativeElement.children).forEach((child, index) => {
      (child as HTMLElement).querySelector('.clip-number')!.innerHTML = `Clip ${index + 1}`;
    });
  }

  addClip(ele: HTMLElement) {
    let totalClips = this.rearrangeClipsContainer.nativeElement.childElementCount;
    let index = parseInt(ele.dataset['index']!);
    let scale = this.generateRearrangeClipsContainer(this.rearrangeClipsContainer.nativeElement, 'rearrange', totalClips, this.defaultClipData[index]);
    this.setImageAndText(document.getElementById(`rearrange-clip-${totalClips}`) as HTMLElement, scale, this.defaultClipData[index], 'rearrange', totalClips);
    this.switchContainer('0%');
    Array.from(this.rearrangeClipsContainer.nativeElement.childNodes).forEach((child: any, index: number) => {
      child.querySelector('.clip-number').innerHTML = `Clip ${index + 1}`;
    });
    ele.parentElement!.style.pointerEvents = 'none';
    setTimeout(() => {
      ele.parentElement!.style.pointerEvents = 'auto';
    }, 600);
  }

  saveRearrangeClips() {
    if (!this.rearrangeClipsContainer) return;

    const updatedData: any[] = [];
    this.rearrangeClipsContainer.nativeElement.querySelectorAll('.rearrange-clip').forEach((clip: Element) => {
      const clipData: any = {};
      const currentClip = document.getElementById(`rearrange-clip-${clip.getAttribute('data-index')}`) as HTMLElement;

      clipData.name = currentClip.dataset['name'];
      clipData.image = currentClip.dataset['src'];
      clipData.bufferStart = parseFloat(currentClip.dataset['bufferstart'] || '0');
      clipData.bufferEnd = parseFloat(currentClip.dataset['bufferend'] || '0');
      clipData.clipDuration = parseFloat(currentClip.dataset['clipduration'] || '0');

      const allText: any[] = [];
      currentClip.querySelectorAll('.clip-text:not(.user-image)').forEach((text) => {
        const textData: any = {};
        const textElement = text as HTMLElement;
        const innerText = textElement.querySelector('.text') as HTMLElement;

        textData.name = textElement.dataset['name'];
        textData.text = innerText ? innerText.innerText : '';
        textData.top = parseFloat(((textElement.offsetTop + 5) / currentClip.offsetHeight * this.globalHeight).toFixed(4));
        textData.left = parseFloat(((textElement.offsetLeft + textElement.offsetWidth / 2) / currentClip.offsetWidth * this.globalWidth).toFixed(4));
        textData.fontSize = parseFloat((parseFloat(textElement.style.fontSize) / currentClip.offsetWidth * 28.917).toFixed(4));
        textData.color = (textElement.style.color.includes('#')) ? textElement.style.color : this.getHexaFromRGBstring(textElement.style.color);
        textData.fontFamily = textElement.style.fontFamily.replace(/"/g, '');
        textData.fontStyle = textElement.getAttribute('font-style');
        textData.textAlign = textElement.style.textAlign;
        textData.lineHeight = parseFloat(textElement.style.lineHeight);
        textData.duplicate = textElement.dataset['duplicate'] || null;
        textData.startAnimation = textElement.getAttribute('start-animation') !== 'null' ? textElement.getAttribute('start-animation') : null;

        allText.push(textData);
      });

      const allIcon: any[] = [];
      currentClip.querySelectorAll('.user-image').forEach((imageDiv) => {
        const image = imageDiv.querySelector('img') as HTMLImageElement;
        const imageElement = imageDiv as HTMLElement;
        const iconData: any = {};

        iconData.name = 'image';
        iconData.url = image.src;
        iconData.height = parseFloat((image.offsetHeight / currentClip.offsetHeight * this.globalHeight).toFixed(4));
        iconData.width = parseFloat((image.offsetWidth / currentClip.offsetWidth * this.globalWidth).toFixed(4));
        iconData.top = parseFloat(((imageElement.offsetTop + (imageElement.offsetHeight / 2)) / currentClip.offsetHeight * this.globalHeight).toFixed(4));
        iconData.left = parseFloat(((imageElement.offsetLeft + (imageElement.offsetWidth / 2)) / currentClip.offsetWidth * this.globalWidth).toFixed(4));

        allIcon.push(iconData);
      });

      clipData.text = allText;
      clipData.userImage = allIcon;
      updatedData.push(clipData);
    });

    this.userData.clipData = updatedData;

    this.verticalContainer.nativeElement!.innerHTML = '';
    this.workspaceContainer.nativeElement.innerHTML = '';
    this.rearrangeClipsContainer.nativeElement.innerHTML = '';

    for (let i = 0; i < updatedData.length; i++) {
      let scale;
      scale = this.generateClipsContainer(this.verticalContainer.nativeElement!, 'vertical', i, updatedData[i]);
      this.setImageAndText(document.getElementById(`vertical-clip-${i}`)!, scale, updatedData[i], 'vertical', i);
      scale = this.generateClipsContainer(this.workspaceContainer.nativeElement!, 'horizontal', i, updatedData[i]);
      this.setImageAndText(document.getElementById(`horizontal-clip-${i}`)!, scale, updatedData[i], 'horizontal', i);
    }

    const rearrangeContainer = document.querySelector('.rearrange-container') as HTMLElement;
    rearrangeContainer.style.display = 'none';
    this.resetWorkspaceView();

    setTimeout(() => {
      this.setDefaultTextProperties();
    }, 1000);
  }

  componentToHex(c: number): string {
    const hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  getHex(r: number, g: number, b: number): string {
    return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
  }

  getHexaFromRGBstring(color: string): string {
    if (color.includes("#")) return color;
    const a = color.split("(")[1].split(")")[0];
    let b = a.split(",").map((x) => {
      x = parseInt(x).toString(16);
      return x.length == 1 ? "0" + x : x;
    });
    return "#" + b.join("");
  }

  changeFixedImage(ele: HTMLElement, type: string | null = null) {
    const parentEle = ele.parentElement as HTMLElement;
    const imageWidth = parseFloat(parentEle.getAttribute('image-width') || '0');
    const imageHeight = parseFloat(parentEle.getAttribute('image-height') || '0');
    this.imageInputType = 'fixedImage';
    this.fixedImageEle = parentEle.querySelector('img') as HTMLImageElement;
    this.fixedCroppedOptions = { dragMode: 'move', preview: '.preview', viewMode: 1, background: false, aspectRatio: imageWidth / imageHeight, cropBoxResizable: false, cropBoxMovable: false };

    this.imageInput.nativeElement.click();
  }

  changeCoupleImage(name: string) {
    this.imageInputType = 'caricature';
    this.fixedImageEle = document.getElementById(`${name}Image`) as HTMLImageElement;
    this.imageInput.nativeElement.click();
  }

  createData() {
    const clips: any[] = [];
    const fixedImages = this.userData.fixedImages;
    const coupleImages: any = {};
    this.userData.music = {
      link: this.audioEle.nativeElement.src,
      name: (document.getElementById('custom-music-name') as HTMLElement).innerText
    };

    this.workspaceContainer.nativeElement.querySelectorAll('.clips-container').forEach((currentClip) => {
      const clipData: any = {};
      const clipElement = currentClip as HTMLElement;
      clipData.name = clipElement.dataset['name'];
      clipData.image = clipElement.dataset['src'];
      clipData.bufferStart = parseFloat(clipElement.dataset['bufferstart'] || '0');
      clipData.bufferEnd = parseFloat(clipElement.dataset['bufferend'] || '0');
      clipData.clipDuration = parseFloat(clipElement.dataset['clipduration'] || '0');

      const allText: any[] = [];
      clipElement.querySelectorAll('.clip-text:not(.user-image)').forEach((text) => {
        const textData: any = {};
        const textElement = text as HTMLElement;
        const innerTextElement = textElement.querySelector('.text') as HTMLElement;

        textData.name = textElement.dataset['name'];
        textData.text = innerTextElement.innerText;
        textData.top = parseFloat(((textElement.offsetTop + 5) / clipElement.offsetHeight * this.globalHeight).toFixed(4));
        textData.left = parseFloat(((textElement.offsetLeft + textElement.offsetWidth / 2) / clipElement.offsetWidth * this.globalWidth).toFixed(4));
        textData.fontSize = parseFloat((parseFloat(textElement.style.fontSize) / clipElement.offsetWidth * this.globalWidth).toFixed(4));
        textData.color = textElement.style.color.includes("#") ? textElement.style.color : this.getHexaFromRGBstring(textElement.style.color);
        textData.fontFamily = textElement.style.fontFamily.replace(/"/g, '');
        textData.fontStyle = textElement.getAttribute('font-style');
        textData.textAlign = textElement.style.textAlign;
        textData.lineHeight = parseFloat(textElement.style.lineHeight);
        textData.duplicate = textElement.dataset['duplicate'] || null;
        textData.startAnimation = textElement.getAttribute('start-animation') != 'null' ? textElement.getAttribute('start-animation') : null;
        allText.push(textData);
      });

      const allIcon: any[] = [];
      clipElement.querySelectorAll('.user-image').forEach((imageDiv) => {
        const image = imageDiv.querySelector('img') as HTMLImageElement;
        const imageDivElement = imageDiv as HTMLElement;
        const iconData: any = {};

        iconData.name = 'image';
        iconData.url = image.src;
        iconData.height = parseFloat((image.offsetHeight / clipElement.offsetHeight * this.globalHeight).toFixed(4));
        iconData.width = parseFloat((image.offsetWidth / clipElement.offsetWidth * this.globalWidth).toFixed(4));
        iconData.top = parseFloat(((imageDivElement.offsetTop + imageDivElement.offsetHeight / 2) / clipElement.offsetHeight * this.globalHeight).toFixed(4));
        iconData.left = parseFloat(((imageDivElement.offsetLeft + imageDivElement.offsetWidth / 2) / clipElement.offsetWidth * this.globalWidth).toFixed(4));
        allIcon.push(iconData);
      });

      clipData.text = allText;
      clipData.userImage = allIcon;
      clips.push(clipData);
    });
    const fixedImagesContainer = this.renderer.selectRootElement('.fixed-images-container', true);
    fixedImagesContainer.querySelectorAll('img').forEach((image: HTMLImageElement, index: number) => {
      if (image.src.includes('blob')) {
        fixedImages[index]['link'] = image.src;
      }
    });

    if (this.userData['caricature']) {
      const coupleImagesContainer = this.renderer.selectRootElement('.couple-images', true);
      coupleImagesContainer.querySelectorAll('img').forEach((image: HTMLImageElement) => {
        coupleImages[image.id] = image.src;
      });
    }

    // this.userData['coupleImages'] = coupleImages;
    // this.userData['title'] = this.videoTitle.nativeElement.value;
    this.userData['clips'] = clips;

    return this.userData;
  }

  // createData() {
  //   let clips: any[] = [];
  //   let fixedImages = this.userData.fixedImages;
  //   let coupleImages: any = {};

  //   this.userData.music = {
  //     linklink: (document.getElementById('custom-music-src') as HTMLMediaElement).src,
  //     name: (document.getElementById('custom-music-name') as HTMLElement).innerText
  //   };

  //   const clipsContainers = document.querySelectorAll('.clips-container');

  //   clipsContainers.forEach((currentClip) => {
  //     let clipData: any = {};
  //     const clipElement = currentClip as HTMLElement;
  //     clipData.name = clipElement.dataset['name'];
  //     clipData.image = clipElement.dataset['src'];
  //     clipData.bufferStart = parseFloat(clipElement.dataset['bufferstart']!);
  //     clipData.bufferEnd = parseFloat(clipElement.dataset['bufferend']!);
  //     clipData.clipDuration = parseFloat(clipElement.dataset['clipduration']!);

  //     let allText: any[] = [];
  //     clipElement.querySelectorAll('.clip-text:not(.user-image)').forEach((text) => {
  //       let textElement = text as HTMLElement;
  //       let textData: any = {};
  //       textData.name = textElement.dataset['name'];
  //       textData.text = textElement.querySelector('.text')!.innerHTML;
  //       textData.top = parseFloat((((textElement.offsetTop + 5) / clipElement.offsetHeight) * this.globalHeight).toFixed(4));
  //       textData.left = parseFloat((((textElement.offsetLeft + textElement.offsetWidth / 2) / clipElement.offsetWidth) * this.globalWidth).toFixed(4));
  //       textData.fontSize = parseFloat((parseFloat(getComputedStyle(textElement).fontSize) / clipElement.offsetWidth * this.globalWidth).toFixed(4));
  //       textData.color = this.getHexaFromRGBstring(getComputedStyle(textElement).color);
  //       textData.fontFamily = getComputedStyle(textElement).fontFamily.replaceAll('"', '');
  //       textData.fontStyle = textElement.getAttribute('font-style');
  //       textData.textAlign = getComputedStyle(textElement).textAlign;
  //       textData.lineHeight = parseFloat(getComputedStyle(textElement).lineHeight);
  //       textData.duplicate = textElement.dataset['duplicate'] || null;
  //       textData.startAnimation = textElement.getAttribute('start-animation') !== 'null' ? textElement.getAttribute('start-animation') : null;
  //       allText.push(textData);
  //     });

  //     let allIcon: any[] = [];
  //     clipElement.querySelectorAll('.user-image').forEach((imageDiv) => {
  //       let imageDivElement = imageDiv as HTMLElement;
  //       const image = imageDivElement.querySelector('img');
  //       if (image) {
  //         let iconData: any = {};
  //         iconData.name = 'image';
  //         iconData.url = image.src;
  //         iconData.height = parseFloat((image.offsetHeight / clipElement.offsetHeight * this.globalHeight).toFixed(4));
  //         iconData.width = parseFloat((image.offsetWidth / clipElement.offsetWidth * this.globalWidth).toFixed(4));
  //         iconData.top = parseFloat((((imageDivElement.offsetTop + imageDivElement.offsetHeight / 2) / clipElement.offsetHeight) * this.globalHeight).toFixed(4));
  //         iconData.left = parseFloat((((imageDivElement.offsetLeft + imageDivElement.offsetWidth / 2) / clipElement.offsetWidth) * this.globalWidth).toFixed(4));
  //         allIcon.push(iconData);
  //       }
  //     });
  //     clipData.text = allText;
  //     clipData.userImage = allIcon;
  //     clips.push(clipData);
  //   });

  //   const fixedImagesContainer = this.renderer.selectRootElement('.fixed-images-container', true);
  //   fixedImagesContainer.querySelectorAll('img').forEach((image: HTMLImageElement, index: number) => {
  //     if (image.src.includes('blob')) {
  //       fixedImages[index]['link'] = image.src;
  //     }
  //   });

  //   if (this.userData['caricature']) {
  //     const coupleImagesContainer = this.renderer.selectRootElement('.couple-images', true);
  //     coupleImagesContainer.querySelectorAll('img').forEach((image: HTMLImageElement) => {
  //       coupleImages[image.id] = image.src;
  //     });
  //   }

  //   this.userData['coupleImages'] = coupleImages;
  //   // this.userData['title'] = this.videoTitle.nativeElement.value;
  //   this.userData['clips'] = clips;

  //   return this.userData;
  // }


  sendVideoDataToCreate(videoJson: any): any {
    const processingJson: any = {
      user_id: this.userId,
      project_id: this.projectId,
      json: videoJson
    };

    let windowLocation = '';
    if (videoJson['watermark']) {
      processingJson['type'] = 'draft';
      windowLocation = 'my-draft';
    } else {
      processingJson['type'] = 'order';
      windowLocation = 'my-order';
    }

    try {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://invitoai.com/invito/api/create_video.php', false); // false for sync
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(processingJson));

      if (xhr.status === 200) {
        const jsonResponse = JSON.parse(xhr.responseText);
        if (jsonResponse.status == 200) {
          this.stopLoader();
          (document.querySelector('.caricature-modal') as HTMLElement).style.display = 'none';
          window.location.href = windowLocation;
        }
        return jsonResponse;
      } else {
        throw new Error('Failed to send video data');
      }
    } catch (error) {
      this.stopLoader();
      console.error(error);
      return error;
    }
  }

  saveVideoData(videoJson: any, type: string) {
    const processingJson: any = {
      user_id: this.userId,
      project_id: this.projectId,
      json: videoJson
    };

    videoJson['type'] = type;
    videoJson['watermark'] = type == 'order' ? false : true;

    const xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://invitoai.com/invito/api/create_update_video_mysql.php', false); // false makes the request synchronous
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(processingJson));

    if (xhr.status === 200) {
      return JSON.parse(xhr.responseText);
    } else {
      throw new Error(`Request failed with status ${xhr.status}`);
    }
  }
  public GenerateVideo(e) {
    if (this.isShowPreviewStatus) {
      this.toastr.warning(
        'Video generation is in progress. Please stay with us.'
      );
      return;
    }
    this.sharedService.isShowLoader.next(true);
    this.createVideo(1);
    // this.subscription.add(
    //   this._httpService
    //     .ajaxPost(
    //       `Personalize/CheckVideoStatus/${this.pUserVideoId}/${this.invitationType}`,
    //       null
    //     )
    //     .subscribe(
    //       (data: any) => {
    //         this.sharedService.isShowLoader.next(false);
    //         if (data) {
    //           if (
    //             (this.generatedVideoPath.length > 0 ||
    //               this.generatedDocumentPath.length > 0) &&
    //             this.isInputChanged == false
    //           ) {
    //             this.openHowItWorksDialog(
    //               this.generatedVideoPath,
    //               this.generatedDocumentPath
    //             );
    //             return;
    //           } else {
    //             if (this.isShowPreviewStatus) {
    //               return;
    //             }
    //             if (!this.isDraftSaved || this.isInputChanged == true)
    //               this.createVideo(1);
    //             else this.processVideoGeneration();

    //             var errorExist = false;

    //             if (errorExist) {
    //               return;
    //             }
    //           }
    //         } else {
    //           if (this.isShowPreviewStatus) {
    //             return;
    //           }
    //           if (!this.isDraftSaved || this.isInputChanged == true)
    //             this.createVideo(1);
    //           else this.processVideoGeneration();

    //           var errorExist = false;

    //           if (errorExist) {
    //             return;
    //           }
    //         }
    //       },
    //       () => {
    //         this.sharedService.isShowLoader.next(false);
    //       }
    //     )
    // );
  }
  createVideo(type: number) {
    // if (!this.checkUserLogin()) return;

    if (this.userData['caricature']) {
      const brideImage = document.getElementById('brideImage') as HTMLImageElement;
      const groomImage = document.getElementById('groomImage') as HTMLImageElement;
      const errorDisplay = document.querySelector('.caricature-content .error') as HTMLElement;

      if (brideImage.src.includes('/images/videoEdit') || groomImage.src.includes('/images/videoEdit')) {
        errorDisplay.style.display = 'flex';
        setTimeout(() => {
          errorDisplay.style.display = 'none';
        }, 1000);
        return;
      }
    }

    this.startLoader();
    let videoData = this.createData();
    videoData['userId'] = this.userId;

    // const priceData = this.changePriceAccordingToCurrency();
    // videoData['price'] = priceData['price'];
    // videoData['currency'] = priceData['currency'];

    this.storeFiles(videoData).then(updatedData => {
      console.log('Processed Data:', updatedData);
      this.defaultData = updatedData;
      this.userData = this.defaultData;
      this.TemplateMetaData.VideoEditorState = updatedData;
      if ((this.generatedVideoPath.length > 0 ||
        this.generatedDocumentPath.length > 0) && _.isEqualWith(updatedData, this.initialVideoEditorState, this.customComparator)) {
        this.openHowItWorksDialog(
          this.generatedVideoPath,
          this.generatedDocumentPath
        );
        this.sharedService.isShowLoader.next(false);
        this.stopLoader();
        return;
      }
      if (type == 0) {
        this.SaveTemplateData(false);
      }
      else if (type == 1) {
        this.SaveTemplateData(true);
      }
      else {
        this.SaveTemplateData(true);
      }
      this.stopLoader();
    });


    // let videoType: string;

    // if (type == 'sample') {
    //   videoData['watermark'] = true;
    //   videoType = 'draft';
    //   if (window.location.href.includes('videoID')) {
    //     if (this.checkDraftCount(this.userId)) {
    //       this.openDraftModal();
    //       return;
    //     }
    //   }
    // } else {
    //   videoType = 'order';
    //   this.closePaymentErrorModal();
    //   this.closeDraftModal();

    //   const paymentId = Math.random().toString(36).slice(5) + Math.random().toString(36).slice(5);

    //   videoData['paymentId'] = paymentId;
    //   this.processPayment(videoData);

    //   const resp = this.checkPaymentStatus(`${videoData['videoId']}_${paymentId}`);
    //   if (resp == 0) {
    //     this.stopLoader();
    //     this.openPaymentErrorModal(paymentId, videoData['price'], videoData['currency']);
    //     return;
    //   }
    //   videoData['watermark'] = false;
    // }

    // videoData['type'] = videoType;
    // this.sendVideoDataToCreate(videoData);
  }
  private customComparator(objValue: any, othValue: any): boolean | undefined {
    // If both values are numbers (integer or decimal), allow a difference of up to 2
    if (typeof objValue === 'number' && typeof othValue === 'number') {
      return Math.abs(objValue - othValue) <= 2;
    }
    // Return undefined for default comparison for other types (string, boolean, objects, etc.)
    return undefined;
  }
  public SaveTemplateData(isGenerateVideo: boolean = false) {
    if (this.isShowPreviewStatus) {
      return;
    }
    this.sharedService.isShowLoader.next(true);


    this.TemplateMetaData.VideoStatus = isGenerateVideo
      ? this.constants.videoStatus.Previewed
      : this.constants.videoStatus.Draft;
    if (this.userDetails != null) {
      if (
        this.TemplateMetaData.userId == null ||
        this.TemplateMetaData.userId == undefined
      )
        this.TemplateMetaData.userId = this.userDetails.UserId;

      this.TemplateMetaData.AudioPath = this.TemplateMetaData.VideoEditorState.music.link;
      this.musicFileName = this.TemplateMetaData.VideoEditorState.music.name;
      this.TemplateMetaData.MarketingAgent = this.marketingAgent;
      this.TemplateMetaData.InvitationType = this.invitationType;
      this.TemplateMetaData.VideoEditorType = 2;

      this._httpService
        .ajaxPost('Personalize/SaveTemplateData', this.TemplateMetaData)
        .subscribe(
          (data) => {
            this.generatedVideoPath = '';
            if (
              data['Message'].MessageTypeValue ==
              this.constants.messageType.Success
            ) {
              this.isDraftSaved = true;
              this.isInputChanged = false;
              var templateDataList = data['TemplateData'];
              this.TemplateMetaData.UserId = this.userDetails.UserId;
              this.TemplateMetaData.UserVideoId = templateDataList.UserVideoId;
              this.TemplateMetaData.TemplateId = templateDataList.TemplateId;
              this.TemplateMetaData.TemplateName =
                templateDataList.TemplateName;
              this.TemplateMetaData.AudioPath = templateDataList.AudioPath;
              this.TemplateMetaData.DefaultAudioPath =
                templateDataList.DefaultAudioPath;
              this.TemplateMetaData.GenerateType =
                templateDataList.GenerateType;
              this.TemplateMetaData.GradeId = templateDataList.GradeId;
              this.previewStyle = templateDataList.PreviewStyle;
              this.audioFilePath =
                this._httpService.baseURLWithOutSlace +
                (templateDataList.AudioPath.indexOf('.') == 0
                  ? templateDataList.AudioPath.substring(1)
                  : templateDataList.AudioPath);
              this.audioFileName = this.audioFilePath
                .replace(/^.*[\\\/]/, '_')
                .replace(/\s/g, '_');
              this.audioFileName = this.replaceBetween(
                this.audioFileName,
                this.audioFileName.lastIndexOf('_'),
                this.audioFileName.lastIndexOf('.'),
                ''
              );
              this.pUserVideoId = templateDataList.UserVideoId;
              var templateDataList = data['TemplateData'];
              this.pUserVideoId = templateDataList.UserVideoId;
              if (!isGenerateVideo) this.toastr.success(data['Message'].Text);
              this.sharedService.isShowLoader.next(false);
              if (isGenerateVideo) {
                this.startVideoGeneration();
              }
            } else {
              this.toastr.error(data['Message'].Text);
              this.sharedService.isShowLoader.next(false);
            }
          },
          (error: any) => {
            this.toastr.error(JSON.parse(error).Message['Text']);
            this.sharedService.isShowLoader.next(false);
          }
        );
    } else {
      const modelRef = this.ngbModel.open(LoginComponent, {
        size: 'lg',
        windowClass: 'login-dialog',
      });
      modelRef.result.then((data) => {
        this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
        if (this.userDetails != null && this.userDetails != '')
          this.SaveTemplateData(isGenerateVideo);
      });
      //this.isShowLoader = false;
      this.sharedService.isShowLoader.next(false);
    }
  }
  startVideoGeneration() {
    this.invokeHubConnection();
  }
  processPayment(data: any): void {
    const paymentData = {
      order_id: `${data['videoId']}_${data['paymentId']}`,
      user_id: data['userId'],
      project_id: data['projectId'],
      currency: data['currency'],
      amount: data['price'] + (data['currency'] == 'INR' ? data['price'] * 0.18 : 0)
    };

    try {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://invitoai.com/invito/api/payment_link.php', false);  // false for synchronous
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(paymentData));

      if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        if (response['status'] == 200) {
          const paymentLink = response['result']['url'];
          window.location.href = paymentLink;
        } else {
          console.error('Payment failed:', response['message']);
        }
      } else {
        throw new Error('Failed to process payment');
      }
    } catch (error) {
      console.error('Error during payment processing:', error);
    }
  }


  checkPaymentStatus(orderId: string): any {
    return new Promise((resolve, reject) => {
      fetch('https://invitoai.com/invito/api/payment_check.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ order_id: orderId })
      })
        .then(response => {
          const paymentResp = response.json();
          if (paymentResp['status'] === 200) {
            resolve(paymentResp['result']['status']);
          } else {
            reject(new Error('API Error'));
          }
        })
        .catch(error => reject(error));
    });
  }

  openPaymentErrorModal(paymentId: string, price: number, currency: string) {
    (document.querySelector('.payment-modal .amount') as HTMLElement).innerHTML = `${price + (currency == 'INR' ? price * 0.18 : 0)}`;
    (document.querySelector('.payment-modal .currency') as HTMLElement).innerHTML = ' ' + currency;
    (document.querySelector('.payment-modal .contact-us') as HTMLElement).onclick = () => {
      window.open(`http://wa.me/919328291116?text=Hey! I have an issue with my transaction with transaction ID: ${paymentId}.&app_absent=1`);
    };
    (document.querySelector('.payment-modal') as HTMLElement).style.display = 'flex';
    setTimeout(() => {
      (document.querySelector('.payment-modal .payment-content') as HTMLElement).style.scale = '1';
    }, 200);
  }

  closePaymentErrorModal() {
    (document.querySelector('.payment-modal .payment-content') as HTMLElement).style.scale = '0';
    setTimeout(() => {
      (document.querySelector('.payment-modal') as HTMLElement).style.display = 'none';
    }, 200);
  }

  checkDraftCount(userId: string): boolean {
    try {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://invitoai.com/invito/api/my_orders.php', false); // false for synchronous
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify({ user_id: userId, type: 'draft' }));

      if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        if (response['status'] === 200) {
          const data = response['result']['data'];
          return data.length >= (this.b2b ? 30 : 3);
        } else {
          return false;
        }
      } else {
        throw new Error('Failed to fetch draft count');
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }


  openDraftModal() {
    (document.querySelector('.draft-modal') as HTMLElement).style.display = 'flex';
    setTimeout(() => {
      (document.querySelector('.draft-modal .draft-content') as HTMLElement).style.scale = '1';
    }, 200);
  }

  closeDraftModal() {
    (document.querySelector('.draft-modal .draft-content') as HTMLElement).style.scale = '0';
    setTimeout(() => {
      (document.querySelector('.draft-modal') as HTMLElement).style.display = 'none';
    }, 200);
  }

  // goToDraft() {
  //   const windowFeatures = 'width=550,height=600,top=50,left=100';
  //   const draftWindow = window.open('/my-draft', '_blank', windowFeatures);
  //   const interval = setInterval(() => {
  //     if (draftWindow && draftWindow.closed) {
  //       clearInterval(interval);
  //       this.createVideo('sample');
  //     }
  //   }, 1000);
  // }

  // async storeFiles(data: any): Promise<any> {
  //   const clipData = data['clips'];
  //   const fixedImageData = data['fixedImages'];
  //   const coupleImages = data['coupleImages'];
  //   const musicData = data['music'];

  //   // Process Clip Data
  //   for (let i = 0; i < clipData.length; i++) {
  //     const userImage = clipData[i]['userImage'];
  //     for (let j = 0; j < userImage.length; j++) {
  //       const imageData = userImage[j]['url'];
  //       if (imageData.includes('blob')) {
  //         try {
  //           const base64 = await this.blobToBase64(imageData);
  //           this.sendDataToBackEnd(base64, 'png', true).subscribe({
  //             next: (fileUrl) => {
  //               clipData[i]['userImage'][j]['url'] = fileUrl;
  //             },
  //             error: (error) => console.error('File upload failed:', error)
  //           });
  //         } catch (error) {
  //           console.error('Error processing clip image:', error);
  //         }
  //       }
  //     }
  //   }

  //   // Process Fixed Image Data
  //   for (let i = 0; i < fixedImageData.length; i++) {
  //     const imageLink = fixedImageData[i]['link'];
  //     if (imageLink.includes('blob')) {
  //       try {
  //         const base64 = await this.blobToBase64(imageLink);
  //         this.sendDataToBackEnd(base64, 'png', true).subscribe({
  //           next: (fileUrl) => {
  //             fixedImageData[i]['link'] = fileUrl;
  //           },
  //           error: (error) => console.error('File upload failed:', error)
  //         });;
  //       } catch (error) {
  //         console.error('Error processing fixed image:', error);
  //       }
  //     }
  //   }

  //   // Process Couple Images
  //   for (const key in coupleImages) {
  //     if (coupleImages[key].includes('blob')) {
  //       try {
  //         const base64 = await this.blobToBase64(coupleImages[key]);
  //         this.sendDataToBackEnd(base64, 'png', true).subscribe({
  //           next: (fileUrl) => {
  //             coupleImages[key] = fileUrl;
  //           },
  //           error: (error) => console.error('File upload failed:', error)
  //         });;
  //       } catch (error) {
  //         console.error('Error processing couple image:', error);
  //       }
  //     }
  //   }

  //   // Process Music Data
  //   if (musicData['link'].includes('blob')) {
  //     try {
  //       const base64 = await this.blobToBase64(musicData['link']);
  //       this.sendDataToBackEnd(base64, 'mp3', false).subscribe({
  //         next: (fileUrl) => {
  //           musicData['link'] = fileUrl;
  //         },
  //         error: (error) => console.error('File upload failed:', error)
  //       });
  //     } catch (error) {
  //       console.error('Error processing music file:', error);
  //     }
  //   }

  //   return data;
  // }
  async storeFiles(data: any): Promise<any> {
    const clipData = data['clips'];
    const fixedImageData = data['fixedImages'];
    const coupleImages = data['coupleImages'];
    const musicData = data['music'];

    const uploadPromises: Promise<void>[] = [];

    // Helper function to upload file and return a Promise
    const uploadFile = async (base64: string, ext: string, isImage: boolean): Promise<string> => {
      return new Promise<string>((resolve, reject) => {
        const json = {
          base64Data: base64.replace(/^data:[^;]+;base64,/, ''),
          extension: ext,
          isImage: isImage,
          UserId: this.userId
        };

        this._httpService.ajaxPost(`UploadFile/upload`, json).pipe(
          map(response => response.fileUrl)
        ).subscribe({
          next: resolve,
          error: reject
        });
      });
    };

    // Process Clip Data
    for (let i = 0; i < clipData.length; i++) {
      const userImage = clipData[i]['userImage'];
      for (let j = 0; j < userImage.length; j++) {
        const imageData = userImage[j]['url'];
        if (imageData.includes('blob')) {
          uploadPromises.push(
            (async () => {
              try {
                const base64 = await this.blobToBase64(imageData);
                clipData[i]['userImage'][j]['url'] = await uploadFile(base64, 'png', true);
              } catch (error) {
                console.error('Error processing clip image:', error);
              }
            })()
          );
        }
      }
    }

    // Process Fixed Image Data
    for (let i = 0; i < fixedImageData.length; i++) {
      const imageLink = fixedImageData[i]['link'];
      if (imageLink.includes('blob')) {
        uploadPromises.push(
          (async () => {
            try {
              const base64 = await this.blobToBase64(imageLink);
              fixedImageData[i]['link'] = await uploadFile(base64, 'png', true);
            } catch (error) {
              console.error('Error processing fixed image:', error);
            }
          })()
        );
      }
    }

    // Process Couple Images
    for (const key in coupleImages) {
      if (coupleImages[key].includes('blob')) {
        uploadPromises.push(
          (async () => {
            try {
              const base64 = await this.blobToBase64(coupleImages[key]);
              coupleImages[key] = await uploadFile(base64, 'png', true);
            } catch (error) {
              console.error('Error processing couple image:', error);
            }
          })()
        );
      }
    }

    // Process Music Data
    if (musicData['link'].includes('blob')) {
      uploadPromises.push(
        (async () => {
          try {
            const base64 = await this.blobToBase64(musicData['link']);
            musicData['link'] = await uploadFile(base64, 'mp3', false);
          } catch (error) {
            console.error('Error processing music file:', error);
          }
        })()
      );
    }

    // Wait for all uploads to complete
    await Promise.all(uploadPromises);

    return data;
  }


  // Synchronous version of blobToBase64
  blobToBase64Sync(blobUrl: string): string | null {
    try {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', blobUrl, false); // Synchronous request
      xhr.responseType = 'blob';
      xhr.send();

      if (xhr.status === 200) {
        const blobData = xhr.response as Blob;
        const reader = new FileReader();
        let base64String: string | null = null;

        reader.onloadend = () => {
          base64String = reader.result as string;
        };

        reader.readAsDataURL(blobData);

        // Wait until FileReader is done
        while (base64String === null) {
          // Busy wait
        }

        return base64String;
      } else {
        console.error('Failed to fetch blob. Status:', xhr.status);
        return null;
      }
    } catch (error) {
      console.error('Error during blob to base64 conversion:', error);
      return null;
    }
  }


  blobToBase64(blobUrl: string): Promise<string> {
    return new Promise((resolve, reject) => {
      fetch(blobUrl)
        .then(response => response.blob())
        .then(blob => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = (error) => reject(error);
        })
        .catch(error => reject(error));
    });
  }

  sendDataToBackEnd(base64: string, ext: string, isImage: boolean = false): Observable<string> {
    const json = { base64Data: base64.replace(/^data:[^;]+;base64,/, ''), extension: ext, isImage: isImage, UserId: this.userId };
    return this._httpService.ajaxPost(
      `UploadFile/upload`,
      json
    ).pipe(
      map(response => response.fileUrl)
    );
  }

  fetchDefaultData(): any {
    try {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', `https://invitoai.com/invito/api/video_details.php?videoId=${this.videoId}`, false); // false for synchronous
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send();

      if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        return response['result']['video'];
      } else {
        throw new Error('Failed to fetch video details');
      }
    } catch (error) {
      console.error('Error fetching video data:', error);
      return error;
    }
  }


  fetchUserData(): any {
    try {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', `https://invitoai.com/invito/api/user_project_details.php?projectId=${this.projectId}`, false); // false for sync
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send();

      if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        const data = response['result']['user_project']['json'];
        this.videoId = response['videoId'];

        if (!response['watermark']) {
          (document.querySelector('.create-video-btn .sample') as HTMLElement)?.remove();
          const recreateText = document.querySelector('.create-video-btn .create-video p:nth-child(1)') as HTMLElement;
          if (recreateText) {
            recreateText.innerHTML = 'Recreate High Quality Video';
          }
          const strikePrice = document.querySelector('.create-video-btn .create-video p .strike-price') as HTMLElement;
          if (strikePrice) {
            strikePrice.remove();
          }
        }
        return data;
      } else {
        throw new Error('Failed to fetch user data');
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      return error;
    }
  }


  openCaricatureModal() {
    this.caricatureModal.nativeElement.style.display = 'flex';
  }

  startLoader() {
    if (!document.getElementById('common-loader')) {
      let loader = document.createElement('div');
      loader.setAttribute('id', 'common-loader');
      loader.setAttribute('style', 'height: 50vh; width: 100%');
      (document.querySelector('.loader-modal .loader') as HTMLElement).appendChild(loader);
      this.startLoadAnimation('common-loader');
    }
    (document.querySelector('.loader-modal') as HTMLElement).style.display = 'flex';
  }

  startLoadAnimation(loaderId: string) {
    lottie.loadAnimation({
      container: document.getElementById(loaderId)!,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/lottie/loader-json.json'
    });
    lottie.setSpeed(2);
  }

  stopLoader() {
    (document.querySelector('.loader-modal') as HTMLElement).style.display = 'none';
  }

  addNewAction(elementType: string, action: string, value: any) {
    this.userActionHistory.splice(this.currentHistoryPointer + 1);
    this.userActionHistory.push([elementType, action, value]);
    this.currentHistoryPointer++;
    this.changeUndoRedoButtonStyle();
  }

  changeUndoRedoButtonStyle() {
    const undoButtons = document.querySelectorAll('.undo') as NodeListOf<HTMLElement>;
    const redoButtons = document.querySelectorAll('.redo') as NodeListOf<HTMLElement>;

    if (this.currentHistoryPointer == -1) {
      undoButtons.forEach((ele) => (ele.style.opacity = '0.3'));
      if (this.userActionHistory.length > 0) {
        redoButtons.forEach((ele) => (ele.style.opacity = '1'));
      } else {
        redoButtons.forEach((ele) => (ele.style.opacity = '0.3'));
      }
    } else if (this.currentHistoryPointer == this.userActionHistory.length - 1) {
      undoButtons.forEach((ele) => (ele.style.opacity = '1'));
      redoButtons.forEach((ele) => (ele.style.opacity = '0.3'));
    } else {
      undoButtons.forEach((ele) => (ele.style.opacity = '1'));
      redoButtons.forEach((ele) => (ele.style.opacity = '1'));
    }
  }

  undo() {
    if (this.currentHistoryPointer >= 0) {
      const lastObject = this.userActionHistory[this.currentHistoryPointer];
      this.updateCurrentState(lastObject, 'undo');
      this.currentHistoryPointer--;
      this.changeUndoRedoButtonStyle();
    }
  }

  redo() {
    if (this.currentHistoryPointer < this.userActionHistory.length - 1) {
      const nextObject = this.userActionHistory[++this.currentHistoryPointer];
      this.updateCurrentState(nextObject, 'redo');
      this.changeUndoRedoButtonStyle();
    }
  }

  updateCurrentState(object: any, action: string) {
    if (object[0] === 'page') {
      return;
    }
    const values = object[2];
    const element = document.getElementById(values[0]) as HTMLElement;
    if (!element) return;

    switch (object[1]) {
      case 'family':
        element.style.fontFamily = action === 'undo' ? values[1] : values[3];
        break;
      case 'weight':
        // this.changeFontWeightOfText(element, action === 'undo' ? values[1] : values[2]);
        break;
      case 'size':
        element.style.fontSize = action === 'undo' ? values[1] : values[2];
        break;
      case 'color':
        element.style.color = action === 'undo' ? values[1] : values[2];
        (document.querySelector('.font-color-container>p .data-color') as HTMLElement).style.backgroundColor = action === 'undo' ? values[1] : values[2];
        break;
      case 'align':
        element.style.textAlign = action === 'undo' ? values[1] : values[2];
        element.setAttribute('align', action === 'undo' ? values[1] : values[2]);
        break;
      case 'lineHeight':
        element.style.lineHeight = action === 'undo' ? values[1] : values[2];
        break;
      case 'add':
        element.style.display = action === 'undo' ? 'none' : 'flex';
        break;
      case 'edit':
        const str = action === 'undo' ? values[1] : values[2];
        element.innerHTML = str.replaceAll('&', '&amp;');
        break;
      case 'remove':
        element.style.display = action === 'undo' ? values[1] : values[2];
        break;
      case 'move':
        element.style.left = `${action === 'undo' ? values[1].x : values[2].x}px`;
        element.style.top = `${action === 'undo' ? values[1].y : values[2].y}px`;
        break;
      case 'scale':
        element.style.fontSize = action === 'undo' ? values[1] : values[2];
        (document.querySelector('.font-size-container .value') as HTMLElement).innerHTML = parseFloat(action === 'undo' ? values[1] : values[2]).toFixed(2);
        break;
    }

    const elementClipIndex = values[0].split('-')[1];
    this.horizontalSwiper.slideTo(parseInt(elementClipIndex));
    this.verticalSwiper.slideTo(parseInt(elementClipIndex));
  }

  handleLoginModal(type: string) {
    const modal = document.querySelector('.login-modal') as HTMLElement;
    modal.style.display = type === 'open' ? 'flex' : 'none';
  }

  setupInputFocusListeners() {
    const inputs = document.querySelectorAll('.right input');
    inputs.forEach((ele) => {
      ele.addEventListener('focus', () => {
        ele.parentElement?.classList.add('active');
      });

      ele.nextElementSibling?.addEventListener('click', () => {
        (ele as HTMLInputElement).focus();
        ele.parentElement?.classList.add('active');
      });

      ele.addEventListener('blur', () => {
        if ((ele as HTMLInputElement).value === '') {
          ele.parentElement?.classList.remove('active');
        }
      });

      if ((ele as HTMLInputElement).value !== '') {
        (ele.nextElementSibling as HTMLElement).style.top = '0';
        (ele.nextElementSibling as HTMLElement).style.translate = '0 -50%';
      }
    });
  }

  showHidePassword(event: Event) {
    let ele = event.currentTarget as HTMLElement;
    const passwordInput = ele.parentElement?.querySelector('input[name=password]') as HTMLInputElement;
    const icon = ele.querySelector('i') as HTMLElement;
    if (passwordInput.type === 'password') {
      icon.classList.add('fa-eye-slash');
      icon.classList.remove('fa-eye');
      passwordInput.type = 'text';
    } else {
      icon.classList.add('fa-eye');
      icon.classList.remove('fa-eye-slash');
      passwordInput.type = 'password';
    }
  }

  goToPage(event: Event) {
    let ele = event.currentTarget as HTMLElement;
    const type = ele.dataset['type'];
    const loginModal = document.querySelector('.login-modal') as HTMLElement;
    if (type === 'signup') {
      loginModal.querySelector('.signup-container')?.classList.add('active');
      loginModal.querySelector('.signin-container')?.classList.remove('active');
    } else if (type === 'signin') {
      loginModal.querySelector('.signup-container')?.classList.remove('active');
      loginModal.querySelector('.reset-container')?.classList.remove('active');
      loginModal.querySelector('.signin-container')?.classList.add('active');
    } else if (type === 'reset') {
      loginModal.querySelector('.reset-container')?.classList.add('active');
      loginModal.querySelector('.signin-container')?.classList.remove('active');
    }
  }

  signIn() {
    const useremail = (document.getElementById('register-email') as HTMLInputElement).value;
    const userpass = (document.getElementById('register-pass') as HTMLInputElement).value;
    if (useremail === '' || userpass === '') return;

    event.preventDefault();
    const userData = JSON.stringify({ email: useremail, password: userpass });

    try {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://invitoai.com/invito/api/login.php', false); // false makes it synchronous
      xhr.setRequestHeader('Content-type', 'application/json');
      xhr.send(userData);

      if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);

        if (response['status'] !== 200) {
          const errorContainer = document.querySelector('.signin-container .error') as HTMLElement;
          errorContainer.style.display = 'block';
          errorContainer.querySelector('p')!.innerHTML = response['title'];
          setTimeout(() => {
            errorContainer.style.display = 'none';
          }, 2000);
        } else {
          const encryptLocalStorage = null; // Replace with appropriate storage handling
          encryptLocalStorage.setItem('Aizwoalsdfy', response['result']);
          this.handleLoginModal('close');
          this.checkUserLogin();
        }
      } else {
        throw new Error('Login request failed');
      }
    } catch (error) {
      console.error('Error during login:', error);
    }
  }


  signUp() {
    const username = (document.getElementById('create-fullname') as HTMLInputElement).value;
    const useremail = (document.getElementById('create-email') as HTMLInputElement).value;
    const userpass = (document.getElementById('create-pass') as HTMLInputElement).value;
    const usernumber = (document.getElementById('create-phonenumber') as HTMLInputElement).value;

    if (username === '' || useremail === '' || userpass === '' || usernumber === '') return;

    event.preventDefault();
    const userData = JSON.stringify({
      name: `${username}|${usernumber}`,
      email: useremail,
      password: userpass
    });

    try {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://invitoai.com/invito/api/register.php', false);  // false makes it synchronous
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(userData);

      if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);

        if (response['status'] !== 200) {
          const errorContainer = document.querySelector('.signup-container .error') as HTMLElement;
          errorContainer.style.display = 'block';
          errorContainer.querySelector('p')!.innerHTML = response['title'];
          setTimeout(() => {
            errorContainer.style.display = 'none';
          }, 2000);
        } else {
          const encryptLocalStorage = null; // Replace with appropriate storage logic
          encryptLocalStorage?.setItem('Aizwoalsdfy', response['result']);
          this.handleLoginModal('close');
          this.checkUserLogin();
        }
      } else {
        throw new Error('Sign-up request failed');
      }
    } catch (error) {
      console.error('Error during sign-up:', error);
    }
  }


  phoneEmailListener(userObj: any) {
    const userCountryCode = userObj.user_country_code;
    const userPhoneNumber = userObj.user_phone_number;
    (document.getElementById('verify-otp') as HTMLElement).style.display = 'none';
    const signInButton = document.querySelector('.signup-container .signin') as HTMLElement;
    signInButton.removeAttribute('disabled');
    signInButton.setAttribute('user-num', `${userCountryCode}${userPhoneNumber}`);
  }

  logOut() {
    const encryptLocalStorage = null;//new EncryptStorage('invito-secret-storage');
    encryptLocalStorage.removeItem('Aizwoalsdfy');
    this.checkUserLogin();
  }

  checkUserLogin() {
    const encryptLocalStorage = null;// new EncryptStorage('invito-secret-storage');
    const userData = encryptLocalStorage.getItem('Aizwoalsdfy');
    if (!userData) {
      this.handleLoginModal('open');
      return false;
    } else {
      const user = userData['user'];
      window['userId'] = user['userId'];
      window['b2b'] = user['b2b'] || 0;
      return true;
    }
  }

  setupMusicCropper() {
    this.canvas = document.getElementById('waveformCanvas') as HTMLCanvasElement;
    this.canvasCtx = this.canvas.getContext('2d');
    this.offscreenCanvas = document.createElement('canvas');
    this.offscreenCtx = this.offscreenCanvas.getContext('2d');
    this.startHandle = document.getElementById('startHandle') as HTMLElement;
    this.endHandle = document.getElementById('endHandle') as HTMLElement;
    this.playbackIndicator = document.getElementById('playbackIndicator') as HTMLElement;

    window.addEventListener('resize', this.resizeCanvas);
  }

  // chooseMusic() {
  //   const musicInputFile = document.getElementById('custom-music-input') as HTMLInputElement;
  //   musicInputFile.oninput = () => {
  //     this.startLoader();
  //     this.audioFile = musicInputFile.files![0];
  //     if (!this.audioFile) return;
  //     const regex = /\.(mp3)$/;
  //     if (!regex.test(this.audioFile.name)) return;
  //     (document.querySelector('.choose-music .music-name') as HTMLElement).innerHTML = this.audioFile.name;
  //     const reader = new FileReader();
  //     reader.onloadend = (e: ProgressEvent<FileReader>) => {
  //       const arrayBuffer = e.target?.result as ArrayBuffer;
  //       this.audioContext.decodeAudioData(arrayBuffer, (buffer) => {
  //         this.audioBuffer = buffer;
  //         this.audioUrl = URL.createObjectURL(this.audioFile);
  //         (document.getElementById('audioEle') as HTMLMediaElement).src = this.audioUrl;
  //         this.getMusicTime();
  //         (document.querySelector('.music-crop-modal') as HTMLElement).style.display = 'flex';
  //         this.startHandle.style.left = '0px';
  //         this.endHandle.style.left = 'calc(100% - 5px)';
  //         this.resizeCanvas();
  //         this.drawWaveform();
  //         this.addMusicInputEventListener();
  //         this.stopLoader();
  //       }, (error) => {
  //         console.error('Error decoding audio data:', error);
  //       });
  //     };
  //     reader.onerror = (error) => {
  //       console.error('Error reading file:', error);
  //     };
  //     reader.readAsArrayBuffer(this.audioFile);
  //   };
  //   musicInputFile.click();
  // }
  chooseMusic(): void {
    let musicInputFile = document.getElementById('custom-music-input') as HTMLInputElement;;

    musicInputFile.oninput = () => {
      this.startLoader();
      this.audioFile = musicInputFile.files[0];
      if (!this.audioFile) {
        this.toastr.warning("Please select valid mp3 file with valid file name.");
        return;
      }

      let regex = /.+\.mp3$/i;
      if (!regex.test(this.audioFile.name)) {
        this.toastr.warning("Please select valid mp3 file with valid file name.");
        return;
      }
      const reader = new FileReader();
      reader.onloadend = (e) => {
        const arrayBuffer = e.target!.result as ArrayBuffer;
        this.audioContext.decodeAudioData(
          arrayBuffer,
          (buffer) => {
            this.audioBuffer = buffer;
            this.audioUrl = URL.createObjectURL(this.audioFile!);
            this.audioEle.nativeElement.src = this.audioUrl;
            this.getMusicTime();
            this.musicCropModal.nativeElement.style.display = 'flex';
            let startHandle = document.getElementById('startHandle') as HTMLElement;
            let endHandle = document.getElementById('endHandle') as HTMLElement;
            startHandle.style.left = '0px';
            endHandle.style.left = 'calc(100% - 5px)';
            this.resizeCanvas();
            this.drawWaveform();
            this.addMusicInputEventListener();
            this.stopLoader();
            document.querySelector('.choose-music .music-name')!.innerHTML = this.audioFile.name;
          },
          (error) => {
            this.toastr.warning(`This file is not playable. Please upload valid mp3 file.`);
            console.error('Error decoding audio data:', error);
            return;
          }
        );
      };
      reader.onerror = (error) => {
        this.toastr.warning(`This file is not playable. Please upload valid mp3 file.`);
        console.error('Error reading file:', error);
        return;
      };
      reader.readAsArrayBuffer(this.audioFile);
    };

    musicInputFile.click();
  }

  handleMusic(event: Event) {
    if (this.isShowPreviewStatus) {
      this.toastr.warning(
        'Action can not be performed. Video generation in progress.'
      );
      event.preventDefault();
      return;
    }
    let ele = event.currentTarget as HTMLElement;
    const audioEle = this.audioEle.nativeElement;
    if (ele.classList.contains('fa-circle-play')) {
      audioEle.play();
      (document.querySelector('.music-player i.fa-circle-play') as HTMLElement).style.display = 'none';
      (document.querySelector('.music-player i.fa-circle-pause') as HTMLElement).style.display = 'block';
    } else {
      audioEle.pause();
      (document.querySelector('.music-player i.fa-circle-play') as HTMLElement).style.display = 'block';
      (document.querySelector('.music-player i.fa-circle-pause') as HTMLElement).style.display = 'none';
    }
  }

  getMusicTime() {
    // const audioEle = document.getElementById('audioEle') as HTMLMediaElement;
    this.audioEle.nativeElement.onloadedmetadata = () => {
      const durationInSeconds = this.audioEle.nativeElement.duration;
      const formattedDuration = this.formatTime(durationInSeconds);
      (document.querySelector('.music-container .music-duration') as HTMLElement).innerHTML = formattedDuration;
    };
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  }

  resizeCanvas = () => {
    const container = document.getElementById('waveformContainer') as HTMLElement;
    this.canvas.width = container.clientWidth;
    this.canvas.height = container.clientHeight;
    this.offscreenCanvas.width = this.canvas.width;
    this.offscreenCanvas.height = this.canvas.height;
    this.drawWaveform();
  }

  addMusicInputEventListener() {
    const startDuration = document.getElementById('start-duration') as HTMLInputElement;
    const endDuration = document.getElementById('end-duration') as HTMLInputElement;

    startDuration.addEventListener('input', function (this: HTMLInputElement) {
      this.value = this.value.replace(/\D/g, '').replace(/^0+(?!$)/, '');
    });

    endDuration.addEventListener('input', function (this: HTMLInputElement) {
      this.value = this.value.replace(/\D/g, '').replace(/^0+(?!$)/, '');
    });

    startDuration.onchange = () => {
      this.startTime = Number(startDuration.value);
      const newLeft = (this.startTime / this.audioBuffer!.duration) * this.canvas.width;
      this.startHandle.style.left = Math.max(0, Math.min(this.endHandle.offsetLeft - this.startHandle.offsetWidth - 1, newLeft)) + 'px';
      this.drawSelectionOverlay();
    };

    endDuration.onchange = () => {
      this.endTime = Number(endDuration.value);
      const newLeft = (this.endTime / this.audioBuffer!.duration) * this.canvas.width;
      this.endHandle.style.left = Math.min(this.canvas.width - 5, Math.max(this.startHandle.offsetLeft + this.startHandle.offsetWidth + 1, newLeft)) + 'px';
      this.drawSelectionOverlay();
    };

    this.startHandle.addEventListener('pointerdown', (event: PointerEvent) => {
      let startX = event.clientX;
      let initialLeft = this.startHandle.offsetLeft;

      const musicStartPointerMove = (event: PointerEvent) => {
        let deltaX = event.clientX - startX;
        let newLeft = initialLeft + deltaX;
        newLeft = Math.max(0, Math.min(this.endHandle.offsetLeft - this.startHandle.offsetWidth - 1, newLeft));
        this.startHandle.style.left = newLeft + 'px';
        this.drawSelectionOverlay();
      };

      const musicStartPointerUp = () => {
        window.removeEventListener('pointermove', musicStartPointerMove);
        window.removeEventListener('pointerup', musicStartPointerUp);
        this.drawWaveform();
      };

      window.addEventListener('pointermove', musicStartPointerMove);
      window.addEventListener('pointerup', musicStartPointerUp);
    });

    this.endHandle.addEventListener('pointerdown', (event: PointerEvent) => {
      let startX = event.clientX;
      let initialLeft = this.endHandle.offsetLeft;

      const musicEndPointerMove = (event: PointerEvent) => {
        let deltaX = event.clientX - startX;
        let newLeft = initialLeft + deltaX;
        newLeft = Math.min(this.canvas.width - 5, Math.max(this.startHandle.offsetLeft + this.startHandle.offsetWidth + 1, newLeft));
        this.endHandle.style.left = newLeft + 'px';
        this.drawSelectionOverlay();
      };

      const musicEndPointerUp = () => {
        window.removeEventListener('pointermove', musicEndPointerMove);
        window.removeEventListener('pointerup', musicEndPointerUp);
        this.drawWaveform();
      };

      window.addEventListener('pointermove', musicEndPointerMove);
      window.addEventListener('pointerup', musicEndPointerUp);
    });
  }

  drawWaveform() {
    if (!this.audioBuffer) return;

    const width = this.canvas.width;
    const height = this.canvas.height;
    const channelData = this.audioBuffer.getChannelData(0);
    let devicePixelRatio = 2;
    let scalingFactor = 1;

    this.offscreenCtx!.clearRect(0, 0, width, height);
    this.offscreenCtx!.fillStyle = 'white';
    this.offscreenCtx!.fillRect(0, 0, width, height);
    this.offscreenCtx!.strokeStyle = 'black';
    this.offscreenCtx!.lineWidth = 2;
    this.offscreenCtx!.imageSmoothingEnabled = false;

    this.offscreenCtx!.beginPath();
    const samplesPerPixel = channelData.length / (width);
    for (let i = 0; i < width; i = i + 4) {
      const start = Math.floor(i * samplesPerPixel);
      const end = Math.floor((i + 1) * samplesPerPixel);
      const min = Math.min(...channelData.slice(start, end));
      const max = Math.max(...channelData.slice(start, end));
      const x = i
      const barHeight = (max - min) * height / 2 / devicePixelRatio / scalingFactor;
      const y = (height / 2) - (barHeight / 2);
      this.offscreenCtx!.moveTo(x, y);
      this.offscreenCtx!.lineTo(x, y + barHeight);
    }
    this.offscreenCtx!.stroke();

    this.canvasCtx!.clearRect(0, 0, width, height);
    this.canvasCtx!.drawImage(this.offscreenCanvas, 0, 0);

    this.drawSelectionOverlay();
  }

  drawSelectionOverlay() {
    const width = this.canvas.width;
    const height = this.canvas.height;

    // Clear only the selection overlay area
    this.canvasCtx!.clearRect(0, 0, width, height);

    // Draw the waveform from the offscreen canvas
    this.canvasCtx!.drawImage(this.offscreenCanvas, 0, 0);

    // Draw the selection area on the main canvas
    const startX = this.startHandle.offsetLeft;
    const endX = this.endHandle.offsetLeft;
    this.canvasCtx!.fillStyle = 'rgba(177, 147, 97, 0.5)';
    this.canvasCtx!.fillRect(startX, 0, endX - startX, height);
    this.updateInputValues();
  }

  updateHandlePositions() {
    const width = this.canvas.width;
    this.startHandle.style.left = (this.startTime / this.audioBuffer!.duration) * width + 'px';
    this.endHandle.style.left = (this.endTime! / this.audioBuffer!.duration) * width + 'px';
  }

  updateInputValues() {
    const width = this.canvas.width;
    this.startTime = Number(((this.startHandle.offsetLeft / width) * this.audioBuffer!.duration).toFixed(0));
    this.endTime = Number(((this.endHandle.offsetLeft / width) * this.audioBuffer!.duration).toFixed(0));
    (document.getElementById('start-duration') as HTMLInputElement).value = this.startTime.toString();
    (document.getElementById('end-duration') as HTMLInputElement).value = this.endTime.toString();
    (document.getElementById('total-duration') as HTMLElement).innerHTML = (this.endTime - this.startTime).toString();
  }

  // playCroppedAudio(event: Event) {
  //   let ele = event.currentTarget as HTMLElement;
  //   if (ele.dataset['action'] === 'pause') {
  //     this.croppedAudioSource.stop();
  //     return;
  //   }
  //   ele.dataset['action'] = 'pause';
  //   ele.querySelector('p')!.innerHTML = 'Pause';
  //   ele.querySelector('i')!.classList.replace('fa-circle-play', 'fa-circle-pause');

  //   const sampleRate = this.audioBuffer!.sampleRate;
  //   const startSample = Math.floor(this.startTime * sampleRate);
  //   const endSample = Math.floor(this.endTime! * sampleRate);
  //   const croppedBuffer = this.audioContext.createBuffer(this.audioBuffer!.numberOfChannels, endSample - startSample, sampleRate);

  //   for (let channel = 0; channel < this.audioBuffer!.numberOfChannels; channel++) {
  //     const channelData = this.audioBuffer!.getChannelData(channel).slice(startSample, endSample);
  //     croppedBuffer.copyToChannel(channelData, channel);
  //   }

  //   this.croppedAudioSource = this.audioContext.createBufferSource();
  //   this.croppedAudioSource.buffer = croppedBuffer;
  //   this.croppedAudioSource.connect(this.audioContext.destination);
  //   this.playbackStartTime = this.audioContext.currentTime;
  //   this.croppedAudioSource.start(this.playbackStartTime);

  //   const totalWidth = this.endHandle.offsetLeft - this.startHandle.offsetLeft;
  //   this.playbackIndicator.style.left = `${(this.startHandle.offsetLeft).toFixed(2)}px`;
  //   this.playbackIndicator.style.display = 'block';
  //   this.animatePlaybackIndicator(ele);
  // }

  // animatePlaybackIndicator(ele: HTMLElement) {
  //   const updateIndicator = () => {
  //     const currentTime = this.audioContext.currentTime;
  //     const elapsed = currentTime - this.playbackStartTime;
  //     const duration = this.endTime! - this.startTime;
  //     const progress = elapsed / duration;
  //     const targetLeft = this.startHandle.offsetLeft + (progress * (this.endHandle.offsetLeft - this.startHandle.offsetLeft));
  //     this.playbackIndicator.style.left = `${targetLeft.toFixed(2)}px`;

  //     if (elapsed < duration) {
  //       this.playbackRequest = requestAnimationFrame(updateIndicator);
  //     } else {
  //       this.croppedAudioSource.stop();
  //     }
  //   };
  //   updateIndicator();
  // }

  playCroppedAudio(event: Event) {
    let ele = event.currentTarget as HTMLElement;
    if (ele.dataset['action'] === 'pause') {
      this.croppedAudioSource.stop();
      return;
    }

    ele.dataset['action'] = 'pause';
    ele.querySelector('p')!.innerHTML = 'Pause';
    ele.querySelector('i')!.classList.replace('fa-circle-play', 'fa-circle-pause');

    const sampleRate = this.audioBuffer.sampleRate;
    const startSample = Math.floor(this.startTime * sampleRate);
    const endSample = Math.floor(this.endTime * sampleRate);
    const croppedBuffer = this.audioContext.createBuffer(
      this.audioBuffer.numberOfChannels,
      endSample - startSample,
      sampleRate
    );

    for (let channel = 0; channel < this.audioBuffer.numberOfChannels; channel++) {
      const channelData = this.audioBuffer.getChannelData(channel).slice(startSample, endSample);
      croppedBuffer.copyToChannel(channelData, channel);
    }

    this.croppedAudioSource = this.audioContext.createBufferSource();
    this.croppedAudioSource.buffer = croppedBuffer;
    this.croppedAudioSource.connect(this.audioContext.destination);

    this.playbackStartTime = this.audioContext.currentTime;
    this.croppedAudioSource.start(this.playbackStartTime);

    const totalWidth =
      this.endHandle.offsetLeft - this.startHandle.offsetLeft;
    this.playbackIndicator.style.left = `${this.startHandle.offsetLeft.toFixed(2)}px`;
    this.playbackIndicator.style.display = 'block';

    this.animatePlaybackIndicator(ele, totalWidth);
    this.croppedAudioSource.onended = () => {
      this.playbackIndicator.style.display = 'none';
      ele.dataset['action'] = 'play';
      ele.querySelector('p')!.innerHTML = 'Play';
      ele.querySelector('i')!.classList.replace('fa-circle-pause', 'fa-circle-play');
      cancelAnimationFrame(this.playbackRequest);
    };
  }

  animatePlaybackIndicator(ele: HTMLElement, totalWidth: number): void {
    const updateIndicator = () => {
      const currentTime = this.audioContext.currentTime;
      const elapsed = currentTime - this.playbackStartTime;
      const duration = this.endTime - this.startTime;
      const progress = elapsed / duration;
      const targetLeft = this.startHandle.offsetLeft + progress * totalWidth;
      this.playbackIndicator.style.left = `${targetLeft.toFixed(2)}px`;

      if (elapsed < duration) {
        this.playbackRequest = requestAnimationFrame(updateIndicator);
      } else {
        this.croppedAudioSource.stop();
      }
    };

    updateIndicator();
  }


  cropAudio() {
    this.startLoader();

    // Initialize XMLHttpRequest to fetch the audio file asynchronously
    const xhr = new XMLHttpRequest();
    xhr.open('GET', this.audioUrl, true);  // 'true' makes the request asynchronous
    xhr.responseType = 'blob';

    // Handle the load event asynchronously
    xhr.onload = () => {
      if (xhr.status === 200) {
        const blob = xhr.response as Blob;

        // Calculate byte range for cropping
        const startByte = Math.floor(this.audioFile.size / this.audioBuffer!.duration * this.startTime);
        const endByte = Math.floor(this.audioFile.size / this.audioBuffer!.duration * this.endTime!);

        // Slice the blob to crop the audio
        const croppedBlob = blob.slice(startByte, endByte);
        this.audioUrl = URL.createObjectURL(croppedBlob);

        // Update the audio source
        this.audioEle.nativeElement.src = this.audioUrl;
        this.getMusicTime();
        this.croppedAudioSource?.stop();
        // Hide modal and stop loader
        (document.querySelector('.music-crop-modal') as HTMLElement).style.display = 'none';

        this.stopLoader();
      } else {
        console.error('Failed to fetch audio file. Status:', xhr.status);
        this.stopLoader();
      }
    };

    // Handle network errors
    xhr.onerror = () => {
      console.error('Network error occurred while fetching audio.');
      this.stopLoader();
    };

    // Send the request
    xhr.send();
  }

  triggerParentInputClick(event: Event): void {
    const target = event.currentTarget as HTMLElement;
    const inputElement = target.querySelector('input') as HTMLInputElement;

    if (inputElement) {
      inputElement.click();
    }
  }

  replaceBetween(input, start, end, what) {
    return input.substring(0, start) + what + input.substring(end);
  }
  convertPascalToCamel(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(item => this.convertPascalToCamel(item));
    } else if (obj !== null && typeof obj === 'object') {
      return Object.keys(obj).reduce((acc, key) => {
        // Convert PascalCase to camelCase
        const camelKey = key.charAt(0).toLowerCase() + key.slice(1);

        acc[camelKey] = this.convertPascalToCamel(obj[key]); // Recursively convert nested objects
        return acc;
      }, {} as Record<string, any>);
    }
    return obj; // Return primitive values as is
  }
  goBack() {
    this.location.back();
  }

  sortFontsByName(fonts: { [key: string]: string[] }): { [key: string]: string[] } {
    return Object.fromEntries(
      Object.entries(fonts).sort(([a], [b]) => a.localeCompare(b))
    );
  }
  customFonts = {
    "Arial": ["Regular", "Bold", "Italic", "BoldItalic"],
    "Baby Girly Script": ["Regular"],
    "Ananda Black Personal Use": ["Regular"],
    "Lato": ["Regular", "BlackItalic", "Bold", "BoldItalic"],
    "Amellinda Weddings": ["Regular"],
    "Calibri": ["Regular", "Bold", "BoldItalic", "Light"],
    "Cardo": ["Regular", "Italic", "Bold"],
    "Golden Hills DEMO": ["Regular"],
    "LEMON MILK": ["Regular", "Bold", "BoldItalic"],
    "Poppins": ["Regular", "Bold", "BoldItalic"],
    "Gotham Black": ["Regular"],
    "GROBOLD": ["Regular"],
    "Kitten Swash": ["Regular"],
    "Honey Florist - Personal Use": ["Regular"],
    "Trajan Pro": ["Regular"],
    "Kaushan Script": ["Regular"],
    "Goudy Old Style": ["Regular", "Bold", "ITALIC"],
    "Candlescript Demo Version": ["Regular"],
    "GoudyTitling-Bold": ["Regular"],
    "Anydore": ["Regular"],
    "RaniscriptW00-Regular": ["Regular"],
    "Kitten Slant": ["Regular"],
    "ShangriLaNF": ["Regular"],
    "Infinite Stroke": ["Regular"],
    "Dandeleon Vintage Demo": ["Regular"],
    "Montserrat": ["Regular", "Bold", "MediumBold", "BlackItalic"],
    "Monya Unguta": ["Regular"],
    "Brighton": ["Regular", "Rough"],
    "Cease-Fire 1": ["Regular"],
    "Brock Script": ["Regular"],
    "Copperplate Gothic Bold": ["Regular"],
    "Copperplate Gothic Light": ["Regular"],
    "Kunstler Script": ["Regular"],
    "Adobe Caslon Pro": ["Regular", "Semibold"],
    "DickensScriptSSK": ["Regular"],
    "Butler": ["Regular", "UltraLight", "Light", "Bold", "ExtraBold", "Black", "MediumBold"],
    "Billion Dreams": ["Regular"],
    "Birch Std": ["Regular"],
    "Boomer Tantrum": ["Regular"],
    "Carnivalee Freakshow": ["Regular"],
    "Nunito": ["Regular", "Black", "Bold", "BoldItalic", "MediumBold"],
    "Pictorial Signature": ["Regular"],
    "Tw Cen MT Condensed Extra Bold": ["Regular"],
    "Mistic": ["Regular"],
    "Master Of Break": ["Regular"],
    "Quiska": ["Regular"],
    "Microsoft Himalaya": ["Regular"],
    "Futuristic Stylish": ["Regular"],
    "Californian FB": ["Regular", "Bold", "Italic"],
    "Century Schoolbook": ["Regular"],
    "BODIDLYbold": ["Regular"],
    "Chock A Block NF": ["Regular"],
    "Bungasai": ["Regular"],
    "ALS Script": ["Regular"],
    "Neocyr": ["Regular"],
    "Nyala": ["Regular"],
    "Cormorant Upright": ["Bold", "MediumBold", "SemiBold"],
    "Comic Sans MS": ["Regular", "Bold", "Italic"],
    "Baskerville Old Face": ["Regular"],
    "Satisfy": ["Regular"],
    "Plantagenet Cherokee": ["Regular"],
    "Palatino Linotype": ["Regular", "Bold", "BoldItalic"],
    "Algerian": ["Regular"],
    "Guttever Bold": ["Regular"],
    "GoodVibrations": ["Regular"],
    "ITC Benguiat Std Book": ["Regular"],
    "Agoda": ["Regular"],
    "Alex Brush": ["Regular"],
    "Josefin Sans": ["Regular", "Light", "Bold"],
    "Bite Chocolate": ["Regular"],
    "Amperzand": ["Regular"],
    "Courgette": ["Regular"],
    "Bluebell": ["Regular"],
    "Ebrima": ["Regular", "Bold"],
    "Baskerville BT": ["Roman", "Bold"],

    "BlackChancery": ["Regular"],
    "Alegreya": ["Regular", "Bold", "Italic"],
    "Gabriola": ["Regular"],
    "Averia Serif": ["Regular", "Bold"],
    "Baloo Bhai 2": ["Regular"],
    "Cambria": ["Regular", "Bold", "Italic"],
    "Arbutus Slab": ["Regular"],
    "Aladin": ["Regular"],

    "Berkshire Swash": ["Regular"],
    "Darleston": ["Regular"],
    "Myriad Pro": ["Regular"],
    "Constantia": ["Regular", "Bold", "Italic"],
    "Amiri": ["Regular", "Bold"],
    "Castellar": ["Regular"],
    "Pioggia": ["Regular"],
    "Abril Fatface": ["Regular"],

    "Abhaya Libre": ["Regular"],
    "Stay In Villa": ["Regular"],
    "Anthony Hunter": ["Regular"],
    "Playfair Display": ["Black", "Bold", "BoldItalic"],
    "Parisienne": ["Regular"],
    "Londrina Solid": ["Regular"],
    "Sriracha": ["Regular"],
    "Sacramento": ["Regular"],
    "Yellowtail": ["Regular"],
    "Baskerville": ["Regular"],
    "Jungle Adventurer": ["Regular"],
    "Amatic SC": ["Regular", "Bold"],
    "TimeBurner": ["Regular"],
    "Reliable DEMO": ["Regular"],
    "Kaisei Opti": ["Regular"],
    "Amsterdam Signature": ["Regular"],
    "Adulatory": ["Regular"],
    "Pacifico": ["Regular"],
    "Mullingar": ["Regular"],
    "Candyful": ["Regular"],
    "Luckiest Guy": ["Regular"],
    "Britannic Bold": ["Regular"],

    "Grand Hotel": ["Regular"],
    "Alista Script": ["Regular"],
    "Allrounder Monument Test": ["Regular"],
    "Acme": ["Regular"],
    "Barber Street_PersonalUseOnly": ["Regular"],
    "Cookie": ["Regular"],
    "Always Smile": ["Regular"],
    "PlaytimeWithHotToddiesOblique": ["Regular"],
    "Gochi Hand": ["Regular"],
    "Oh Whale": ["Regular"],
    "Nugelo": ["Regular"],
    "Mussica": ["Regular"],
    "Embassy BT": ["Regular"],
    "Caroni": ["Regular"],
    "Dancing Script": ["Regular", "MediumBold", "SemiBold", "Bold"],
    "Rochester": ["Regular"],

    "Frankfurter Std": ["Regular"],
    "Anja Eliane": ["Regular"],
    "Poor Richard": ["Regular"],
    "Feeling Lovely": ["Regular"],
    "Aclonica": ["Regular"],
    "High Tower Text": ["Regular"],

    "Airthay": ["Regular"],
    "Agenda King": ["Regular"],
    "Centaur": ["Regular"],
    "Amalina": ["Regular"],
    "Activists": ["Regular"],
    "Agency FB": ["Regular"],
    "Amsterdian": ["Regular"],
    "28 Days Later": ["Regular"],
    "Autography": ["Regular"],
    "Annabel 1": ["Regular"],
    "Aulyars": ["Regular"],
    "Beautiful People Personal Use": ["Regular"],
    "Anime": ["Regular"],
    "Sylfaen": ["Regular"],
    "Bodoni MT": ["Regular"],
    "UVF Mussica Swash": ["Regular"],
    "Nazelia Script": ["Regular"],
    "&Matchmaker": ["Regular"],
    "Felix Titling": ["Regular"],
    "Birmingham Script": ["Regular"],
    "Bollent": ["Regular"],
    "Bell MT": ["Regular"],
    "Happy-Dance": ["Regular"],
    "AMS Aaditya": ["Regular"],
    "Andasia Personal Use": ["Regular"],
    "Jokerman": ["Regular"],
    "El Messiri": ["Regular"],
    "Amarithe": ["Regular"],
    "Allura": ["Regular"],





  }

  customFonts_Hindi = {
    "Rozha One": ["Regular"],
    "Laila": ["Regular"],
    "Arya": ["Regular"],
    "Chanakya": ["Regular"],
    "Mangal": ["Regular"],
    "Kruti Dev 010": ["Regular"],
  }

  customFonts_Gujarati = {
    "Gujrati Saral-1": ["Regular"],
    "Rasa": ["Regular", "Bold", "MediumBold", "Italic"],
    "EKLG-01": ["Regular"],
    "EKLG-02": ["Regular"],
    "EKLG-05": ["Regular", "Bold"],
    "EKLG-06": ["Regular", "Bold"],
    "EKLG-07": ["Regular", "Bold"],
    "EKLG-08": ["Regular"],
    "EKLG-10": ["Regular"],
    "EKLG-13B": ["Regular"],
    "EKLG-19": ["Regular"],
    "EKLG-21": ["Regular"],
    "EKLG-24": ["Regular"],
    "EKLG-13": ["Regular", "Bold"],
    "EklG-14": ["Regular", "Bold"],
    "EKLG-20": ["Regular", "Bold"],
    "EKLG-23": ["Regular", "Bold"],
    "EKLG-27 Rinesh": ["Regular"],
    "EKLG-31 Rinesh": ["Regular"],
    "EKLG-45 Rinesh": ["Regular"],

    "EKLG-26 Rinesh": ["Regular", "Italic"],
    "EKLG-29 Rinesh": ["Regular", "Italic"],
    "EKLG-30 Rinesh": ["Regular", "Italic"],
    "EKLG-32 Rinesh": ["Regular", "Italic"],
    "EKLG-33 Rinesh": ["Regular", "Italic"],
    "EKLG-39 Rinesh": ["Regular", "Italic"],
    "EKLG-41 Rinesh": ["Regular", "Italic"],
    "EKLG-43 Rinesh": ["Regular", "Italic"],
    "EKLG-44 Rinesh": ["Regular", "Italic"],
    "EKLG-47 Rinesh": ["Regular", "Italic"],

  }

  customFonts_Tamil = {
    "SunTommy": ["Regular"],
    "VANAVIL-Avvaiyar": ["Regular"],
  }

  customFonts_Telugu = {
    "Ponnala": ["Regular"],
    "Potti Sreeramulu": ["Regular"],
  }

  customFonts_Marathi = {
    "AMS Aaditya": ["Regular"],
  }

  customFonts_Arabic = {
    "Baloo Bhaijaan": ["Regular"],
    "Jomhuria": ["Regular"],
    "Lateef": ["Regular"],
    "Mothanna": ["Regular", "Bold"],
    "Droid Arabic Kufi": ["Regular", "Bold"],
  }

  customFonts_Kannada = {
    "Nudi 17 e": ["Regular"],
    "Nudi 27 e": ["Regular"],
    "Nudi 01 e": ["Regular", "Bold"],
  }

}

